(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("deepmerge"), require("eth-block-tracker-es5"), require("is-plain-object"), require("redux"), require("redux-saga"), require("web3"));else if (typeof define === 'function' && define.amd) define(["deepmerge", "eth-block-tracker-es5", "is-plain-object", "redux", "redux-saga", "web3"], factory);else if (typeof exports === 'object') exports["drizzle"] = factory(require("deepmerge"), require("eth-block-tracker-es5"), require("is-plain-object"), require("redux"), require("redux-saga"), require("web3"));else root["drizzle"] = factory(root["deepmerge"], root["eth-block-tracker-es5"], root["is-plain-object"], root["redux"], root["redux-saga"], root["web3"]);
})(window, function (__WEBPACK_EXTERNAL_MODULE_deepmerge__, __WEBPACK_EXTERNAL_MODULE_eth_block_tracker__, __WEBPACK_EXTERNAL_MODULE_is_plain_object__, __WEBPACK_EXTERNAL_MODULE_redux__, __WEBPACK_EXTERNAL_MODULE_redux_saga__, __WEBPACK_EXTERNAL_MODULE_web3__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = "./src/index.js");
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "./node_modules/babel-runtime/core-js/array/from.js":
      /*!**********************************************************!*\
        !*** ./node_modules/babel-runtime/core-js/array/from.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsArrayFromJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/array/from */
          "./node_modules/core-js/library/fn/array/from.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/core-js/json/stringify.js":
      /*!**************************************************************!*\
        !*** ./node_modules/babel-runtime/core-js/json/stringify.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsJsonStringifyJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/json/stringify */
          "./node_modules/core-js/library/fn/json/stringify.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/core-js/object/assign.js":
      /*!*************************************************************!*\
        !*** ./node_modules/babel-runtime/core-js/object/assign.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsObjectAssignJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/object/assign */
          "./node_modules/core-js/library/fn/object/assign.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/core-js/object/define-property.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/babel-runtime/core-js/object/define-property.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsObjectDefinePropertyJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/object/define-property */
          "./node_modules/core-js/library/fn/object/define-property.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/core-js/object/keys.js":
      /*!***********************************************************!*\
        !*** ./node_modules/babel-runtime/core-js/object/keys.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsObjectKeysJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/object/keys */
          "./node_modules/core-js/library/fn/object/keys.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/core-js/promise.js":
      /*!*******************************************************!*\
        !*** ./node_modules/babel-runtime/core-js/promise.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsPromiseJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/promise */
          "./node_modules/core-js/library/fn/promise.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/core-js/symbol.js":
      /*!******************************************************!*\
        !*** ./node_modules/babel-runtime/core-js/symbol.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsSymbolJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/symbol */
          "./node_modules/core-js/library/fn/symbol/index.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/core-js/symbol/iterator.js":
      /*!***************************************************************!*\
        !*** ./node_modules/babel-runtime/core-js/symbol/iterator.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsSymbolIteratorJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/symbol/iterator */
          "./node_modules/core-js/library/fn/symbol/iterator.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/helpers/classCallCheck.js":
      /*!**************************************************************!*\
        !*** ./node_modules/babel-runtime/helpers/classCallCheck.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersClassCallCheckJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        exports.default = function (instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        };
        /***/

      },

      /***/
      "./node_modules/babel-runtime/helpers/createClass.js":
      /*!***********************************************************!*\
        !*** ./node_modules/babel-runtime/helpers/createClass.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersCreateClassJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _defineProperty = __webpack_require__(
        /*! ../core-js/object/define-property */
        "./node_modules/babel-runtime/core-js/object/define-property.js");

        var _defineProperty2 = _interopRequireDefault(_defineProperty);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              (0, _defineProperty2.default)(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        /***/

      },

      /***/
      "./node_modules/babel-runtime/helpers/defineProperty.js":
      /*!**************************************************************!*\
        !*** ./node_modules/babel-runtime/helpers/defineProperty.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersDefinePropertyJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _defineProperty = __webpack_require__(
        /*! ../core-js/object/define-property */
        "./node_modules/babel-runtime/core-js/object/define-property.js");

        var _defineProperty2 = _interopRequireDefault(_defineProperty);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function (obj, key, value) {
          if (key in obj) {
            (0, _defineProperty2.default)(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        };
        /***/

      },

      /***/
      "./node_modules/babel-runtime/helpers/extends.js":
      /*!*******************************************************!*\
        !*** ./node_modules/babel-runtime/helpers/extends.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersExtendsJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _assign = __webpack_require__(
        /*! ../core-js/object/assign */
        "./node_modules/babel-runtime/core-js/object/assign.js");

        var _assign2 = _interopRequireDefault(_assign);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = _assign2.default || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };
        /***/

      },

      /***/
      "./node_modules/babel-runtime/helpers/toConsumableArray.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/babel-runtime/helpers/toConsumableArray.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersToConsumableArrayJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _from = __webpack_require__(
        /*! ../core-js/array/from */
        "./node_modules/babel-runtime/core-js/array/from.js");

        var _from2 = _interopRequireDefault(_from);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function (arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          } else {
            return (0, _from2.default)(arr);
          }
        };
        /***/

      },

      /***/
      "./node_modules/babel-runtime/helpers/typeof.js":
      /*!******************************************************!*\
        !*** ./node_modules/babel-runtime/helpers/typeof.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersTypeofJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _iterator = __webpack_require__(
        /*! ../core-js/symbol/iterator */
        "./node_modules/babel-runtime/core-js/symbol/iterator.js");

        var _iterator2 = _interopRequireDefault(_iterator);

        var _symbol = __webpack_require__(
        /*! ../core-js/symbol */
        "./node_modules/babel-runtime/core-js/symbol.js");

        var _symbol2 = _interopRequireDefault(_symbol);

        var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
        };

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
          return typeof obj === "undefined" ? "undefined" : _typeof(obj);
        } : function (obj) {
          return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
        };
        /***/
      },

      /***/
      "./node_modules/babel-runtime/regenerator/index.js":
      /*!*********************************************************!*\
        !*** ./node_modules/babel-runtime/regenerator/index.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeRegeneratorIndexJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! regenerator-runtime */
        "./node_modules/regenerator-runtime/runtime-module.js");
        /***/
      },

      /***/
      "./node_modules/core-js/library/fn/array/from.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/library/fn/array/from.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnArrayFromJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.string.iterator */
        "./node_modules/core-js/library/modules/es6.string.iterator.js");

        __webpack_require__(
        /*! ../../modules/es6.array.from */
        "./node_modules/core-js/library/modules/es6.array.from.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_core */
        "./node_modules/core-js/library/modules/_core.js").Array.from;
        /***/
      },

      /***/
      "./node_modules/core-js/library/fn/json/stringify.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/library/fn/json/stringify.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnJsonStringifyJs(module, exports, __webpack_require__) {
        var core = __webpack_require__(
        /*! ../../modules/_core */
        "./node_modules/core-js/library/modules/_core.js");

        var $JSON = core.JSON || (core.JSON = {
          stringify: JSON.stringify
        });

        module.exports = function stringify(it) {
          // eslint-disable-line no-unused-vars
          return $JSON.stringify.apply($JSON, arguments);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/fn/object/assign.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/library/fn/object/assign.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnObjectAssignJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.object.assign */
        "./node_modules/core-js/library/modules/es6.object.assign.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_core */
        "./node_modules/core-js/library/modules/_core.js").Object.assign;
        /***/
      },

      /***/
      "./node_modules/core-js/library/fn/object/define-property.js":
      /*!*******************************************************************!*\
        !*** ./node_modules/core-js/library/fn/object/define-property.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnObjectDefinePropertyJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.object.define-property */
        "./node_modules/core-js/library/modules/es6.object.define-property.js");

        var $Object = __webpack_require__(
        /*! ../../modules/_core */
        "./node_modules/core-js/library/modules/_core.js").Object;

        module.exports = function defineProperty(it, key, desc) {
          return $Object.defineProperty(it, key, desc);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/fn/object/keys.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/library/fn/object/keys.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnObjectKeysJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.object.keys */
        "./node_modules/core-js/library/modules/es6.object.keys.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_core */
        "./node_modules/core-js/library/modules/_core.js").Object.keys;
        /***/
      },

      /***/
      "./node_modules/core-js/library/fn/promise.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/library/fn/promise.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnPromiseJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../modules/es6.object.to-string */
        "./node_modules/core-js/library/modules/es6.object.to-string.js");

        __webpack_require__(
        /*! ../modules/es6.string.iterator */
        "./node_modules/core-js/library/modules/es6.string.iterator.js");

        __webpack_require__(
        /*! ../modules/web.dom.iterable */
        "./node_modules/core-js/library/modules/web.dom.iterable.js");

        __webpack_require__(
        /*! ../modules/es6.promise */
        "./node_modules/core-js/library/modules/es6.promise.js");

        __webpack_require__(
        /*! ../modules/es7.promise.finally */
        "./node_modules/core-js/library/modules/es7.promise.finally.js");

        __webpack_require__(
        /*! ../modules/es7.promise.try */
        "./node_modules/core-js/library/modules/es7.promise.try.js");

        module.exports = __webpack_require__(
        /*! ../modules/_core */
        "./node_modules/core-js/library/modules/_core.js").Promise;
        /***/
      },

      /***/
      "./node_modules/core-js/library/fn/symbol/index.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/library/fn/symbol/index.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnSymbolIndexJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.symbol */
        "./node_modules/core-js/library/modules/es6.symbol.js");

        __webpack_require__(
        /*! ../../modules/es6.object.to-string */
        "./node_modules/core-js/library/modules/es6.object.to-string.js");

        __webpack_require__(
        /*! ../../modules/es7.symbol.async-iterator */
        "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js");

        __webpack_require__(
        /*! ../../modules/es7.symbol.observable */
        "./node_modules/core-js/library/modules/es7.symbol.observable.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_core */
        "./node_modules/core-js/library/modules/_core.js").Symbol;
        /***/
      },

      /***/
      "./node_modules/core-js/library/fn/symbol/iterator.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/fn/symbol/iterator.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnSymbolIteratorJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.string.iterator */
        "./node_modules/core-js/library/modules/es6.string.iterator.js");

        __webpack_require__(
        /*! ../../modules/web.dom.iterable */
        "./node_modules/core-js/library/modules/web.dom.iterable.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_wks-ext */
        "./node_modules/core-js/library/modules/_wks-ext.js").f('iterator');
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_a-function.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_a-function.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_aFunctionJs(module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_add-to-unscopables.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_add-to-unscopables.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_addToUnscopablesJs(module, exports) {
        module.exports = function () {
          /* empty */
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_an-instance.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_an-instance.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_anInstanceJs(module, exports) {
        module.exports = function (it, Constructor, name, forbiddenField) {
          if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
            throw TypeError(name + ': incorrect invocation!');
          }

          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_an-object.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_an-object.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_anObjectJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/library/modules/_is-object.js");

        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_array-includes.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_array-includes.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_arrayIncludesJs(module, exports, __webpack_require__) {
        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/library/modules/_to-iobject.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/library/modules/_to-length.js");

        var toAbsoluteIndex = __webpack_require__(
        /*! ./_to-absolute-index */
        "./node_modules/core-js/library/modules/_to-absolute-index.js");

        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare

            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++]; // eslint-disable-next-line no-self-compare

              if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
            }
            return !IS_INCLUDES && -1;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_classof.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_classof.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_classofJs(module, exports, __webpack_require__) {
        // getting tag from 19.1.3.6 Object.prototype.toString()
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/library/modules/_cof.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('toStringTag'); // ES3 wrong here


        var ARG = cof(function () {
          return arguments;
        }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

        var tryGet = function tryGet(it, key) {
          try {
            return it[key];
          } catch (e) {
            /* empty */
          }
        };

        module.exports = function (it) {
          var O, T, B;
          return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
          : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
          : ARG ? cof(O) // ES3 arguments fallback
          : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_cof.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_cof.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_cofJs(module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_core.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_core.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_coreJs(module, exports) {
        var core = module.exports = {
          version: '2.5.3'
        };
        if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_create-property.js":
      /*!******************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_create-property.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_createPropertyJs(module, exports, __webpack_require__) {
        "use strict";

        var $defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/library/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/library/modules/_property-desc.js");

        module.exports = function (object, index, value) {
          if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_ctx.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_ctx.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_ctxJs(module, exports, __webpack_require__) {
        // optional / simple context binding
        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/library/modules/_a-function.js");

        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;

          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a);
              };

            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };

            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }

          return function ()
          /* ...args */
          {
            return fn.apply(that, arguments);
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_defined.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_defined.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_definedJs(module, exports) {
        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_descriptors.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_descriptors.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_descriptorsJs(module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/library/modules/_fails.js")(function () {
          return Object.defineProperty({}, 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_dom-create.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_dom-create.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_domCreateJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/library/modules/_is-object.js");

        var document = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js").document; // typeof document.createElement is 'object' in old IE


        var is = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return is ? document.createElement(it) : {};
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_enum-bug-keys.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_enum-bug-keys.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_enumBugKeysJs(module, exports) {
        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_enum-keys.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_enum-keys.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_enumKeysJs(module, exports, __webpack_require__) {
        // all enumerable object keys, includes symbols
        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/library/modules/_object-keys.js");

        var gOPS = __webpack_require__(
        /*! ./_object-gops */
        "./node_modules/core-js/library/modules/_object-gops.js");

        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/library/modules/_object-pie.js");

        module.exports = function (it) {
          var result = getKeys(it);
          var getSymbols = gOPS.f;

          if (getSymbols) {
            var symbols = getSymbols(it);
            var isEnum = pIE.f;
            var i = 0;
            var key;

            while (symbols.length > i) {
              if (isEnum.call(it, key = symbols[i++])) result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_export.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_export.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_exportJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/library/modules/_core.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/library/modules/_ctx.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/library/modules/_hide.js");

        var PROTOTYPE = 'prototype';

        var $export = function $export(type, name, source) {
          var IS_FORCED = type & $export.F;
          var IS_GLOBAL = type & $export.G;
          var IS_STATIC = type & $export.S;
          var IS_PROTO = type & $export.P;
          var IS_BIND = type & $export.B;
          var IS_WRAP = type & $export.W;
          var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
          var expProto = exports[PROTOTYPE];
          var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
          var key, own, out;
          if (IS_GLOBAL) source = name;

          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined;
            if (own && key in exports) continue; // export native or passed

            out = own ? target[key] : source[key]; // prevent global pollution for namespaces

            exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
            : IS_BIND && own ? ctx(out, global) // wrap global constructors for prevent change them in library
            : IS_WRAP && target[key] == out ? function (C) {
              var F = function F(a, b, c) {
                if (this instanceof C) {
                  switch (arguments.length) {
                    case 0:
                      return new C();

                    case 1:
                      return new C(a);

                    case 2:
                      return new C(a, b);
                  }

                  return new C(a, b, c);
                }

                return C.apply(this, arguments);
              };

              F[PROTOTYPE] = C[PROTOTYPE];
              return F; // make static versions for prototype methods
            }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

            if (IS_PROTO) {
              (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

              if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
            }
          }
        }; // type bitmap


        $export.F = 1; // forced

        $export.G = 2; // global

        $export.S = 4; // static

        $export.P = 8; // proto

        $export.B = 16; // bind

        $export.W = 32; // wrap

        $export.U = 64; // safe

        $export.R = 128; // real proto method for `library`

        module.exports = $export;
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_fails.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_fails.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_failsJs(module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_for-of.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_for-of.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_forOfJs(module, exports, __webpack_require__) {
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/library/modules/_ctx.js");

        var call = __webpack_require__(
        /*! ./_iter-call */
        "./node_modules/core-js/library/modules/_iter-call.js");

        var isArrayIter = __webpack_require__(
        /*! ./_is-array-iter */
        "./node_modules/core-js/library/modules/_is-array-iter.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/library/modules/_an-object.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/library/modules/_to-length.js");

        var getIterFn = __webpack_require__(
        /*! ./core.get-iterator-method */
        "./node_modules/core-js/library/modules/core.get-iterator-method.js");

        var BREAK = {};
        var RETURN = {};

        var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
          var iterFn = ITERATOR ? function () {
            return iterable;
          } : getIterFn(iterable);
          var f = ctx(fn, that, entries ? 2 : 1);
          var index = 0;
          var length, step, iterator, result;
          if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

          if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
            result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
            if (result === BREAK || result === RETURN) return result;
          } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
            result = call(iterator, f, step.value, entries);
            if (result === BREAK || result === RETURN) return result;
          }
        };

        exports.BREAK = BREAK;
        exports.RETURN = RETURN;
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_global.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_global.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_globalJs(module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
        : Function('return this')();
        if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_has.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_has.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_hasJs(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_hide.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_hide.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_hideJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/library/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/library/modules/_property-desc.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
          return dP.f(object, key, createDesc(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_html.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_html.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_htmlJs(module, exports, __webpack_require__) {
        var document = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js").document;

        module.exports = document && document.documentElement;
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_ie8-dom-define.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_ie8-dom-define.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_ie8DomDefineJs(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/library/modules/_fails.js")(function () {
          return Object.defineProperty(__webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_invoke.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_invoke.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_invokeJs(module, exports) {
        // fast apply, http://jsperf.lnkit.com/fast-apply/5
        module.exports = function (fn, args, that) {
          var un = that === undefined;

          switch (args.length) {
            case 0:
              return un ? fn() : fn.call(that);

            case 1:
              return un ? fn(args[0]) : fn.call(that, args[0]);

            case 2:
              return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

            case 3:
              return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

            case 4:
              return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
          }

          return fn.apply(that, args);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_iobject.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_iobject.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iobjectJs(module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/library/modules/_cof.js"); // eslint-disable-next-line no-prototype-builtins


        module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
          return cof(it) == 'String' ? it.split('') : Object(it);
        };
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_is-array-iter.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_is-array-iter.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_isArrayIterJs(module, exports, __webpack_require__) {
        // check on default Array iterator
        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/library/modules/_iterators.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('iterator');

        var ArrayProto = Array.prototype;

        module.exports = function (it) {
          return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_is-array.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_is-array.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_isArrayJs(module, exports, __webpack_require__) {
        // 7.2.2 IsArray(argument)
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/library/modules/_cof.js");

        module.exports = Array.isArray || function isArray(arg) {
          return cof(arg) == 'Array';
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_is-object.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_is-object.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_isObjectJs(module, exports) {
        module.exports = function (it) {
          return typeof it === 'object' ? it !== null : typeof it === 'function';
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_iter-call.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_iter-call.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterCallJs(module, exports, __webpack_require__) {
        // call something on iterator step with safe closing on error
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/library/modules/_an-object.js");

        module.exports = function (iterator, fn, value, entries) {
          try {
            return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
          } catch (e) {
            var ret = iterator['return'];
            if (ret !== undefined) anObject(ret.call(iterator));
            throw e;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_iter-create.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_iter-create.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterCreateJs(module, exports, __webpack_require__) {
        "use strict";

        var create = __webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/library/modules/_object-create.js");

        var descriptor = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/library/modules/_property-desc.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/library/modules/_set-to-string-tag.js");

        var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

        __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('iterator'), function () {
          return this;
        });

        module.exports = function (Constructor, NAME, next) {
          Constructor.prototype = create(IteratorPrototype, {
            next: descriptor(1, next)
          });
          setToStringTag(Constructor, NAME + ' Iterator');
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_iter-define.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_iter-define.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterDefineJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/library/modules/_library.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/library/modules/_redefine.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/library/modules/_hide.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/library/modules/_has.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/library/modules/_iterators.js");

        var $iterCreate = __webpack_require__(
        /*! ./_iter-create */
        "./node_modules/core-js/library/modules/_iter-create.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/library/modules/_set-to-string-tag.js");

        var getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "./node_modules/core-js/library/modules/_object-gpo.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('iterator');

        var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

        var FF_ITERATOR = '@@iterator';
        var KEYS = 'keys';
        var VALUES = 'values';

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
          $iterCreate(Constructor, NAME, next);

          var getMethod = function getMethod(kind) {
            if (!BUGGY && kind in proto) return proto[kind];

            switch (kind) {
              case KEYS:
                return function keys() {
                  return new Constructor(this, kind);
                };

              case VALUES:
                return function values() {
                  return new Constructor(this, kind);
                };
            }

            return function entries() {
              return new Constructor(this, kind);
            };
          };

          var TAG = NAME + ' Iterator';
          var DEF_VALUES = DEFAULT == VALUES;
          var VALUES_BUG = false;
          var proto = Base.prototype;
          var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
          var $default = !BUGGY && $native || getMethod(DEFAULT);
          var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
          var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
          var methods, key, IteratorPrototype; // Fix native

          if ($anyNative) {
            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
              // Set @@toStringTag to native iterators
              setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

              if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
            }
          } // fix Array#{values, @@iterator}.name in V8 / FF


          if (DEF_VALUES && $native && $native.name !== VALUES) {
            VALUES_BUG = true;

            $default = function values() {
              return $native.call(this);
            };
          } // Define iterator


          if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
            hide(proto, ITERATOR, $default);
          } // Plug for library


          Iterators[NAME] = $default;
          Iterators[TAG] = returnThis;

          if (DEFAULT) {
            methods = {
              values: DEF_VALUES ? $default : getMethod(VALUES),
              keys: IS_SET ? $default : getMethod(KEYS),
              entries: $entries
            };
            if (FORCED) for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
          }

          return methods;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_iter-detect.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_iter-detect.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterDetectJs(module, exports, __webpack_require__) {
        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('iterator');

        var SAFE_CLOSING = false;

        try {
          var riter = [7][ITERATOR]();

          riter['return'] = function () {
            SAFE_CLOSING = true;
          }; // eslint-disable-next-line no-throw-literal


          Array.from(riter, function () {
            throw 2;
          });
        } catch (e) {
          /* empty */
        }

        module.exports = function (exec, skipClosing) {
          if (!skipClosing && !SAFE_CLOSING) return false;
          var safe = false;

          try {
            var arr = [7];
            var iter = arr[ITERATOR]();

            iter.next = function () {
              return {
                done: safe = true
              };
            };

            arr[ITERATOR] = function () {
              return iter;
            };

            exec(arr);
          } catch (e) {
            /* empty */
          }

          return safe;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_iter-step.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_iter-step.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterStepJs(module, exports) {
        module.exports = function (done, value) {
          return {
            value: value,
            done: !!done
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_iterators.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_iterators.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iteratorsJs(module, exports) {
        module.exports = {};
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_library.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_library.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_libraryJs(module, exports) {
        module.exports = true;
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_meta.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_meta.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_metaJs(module, exports, __webpack_require__) {
        var META = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/library/modules/_uid.js")('meta');

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/library/modules/_is-object.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/library/modules/_has.js");

        var setDesc = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/library/modules/_object-dp.js").f;

        var id = 0;

        var isExtensible = Object.isExtensible || function () {
          return true;
        };

        var FREEZE = !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/library/modules/_fails.js")(function () {
          return isExtensible(Object.preventExtensions({}));
        });

        var setMeta = function setMeta(it) {
          setDesc(it, META, {
            value: {
              i: 'O' + ++id,
              // object ID
              w: {} // weak collections IDs

            }
          });
        };

        var fastKey = function fastKey(it, create) {
          // return primitive with prefix
          if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return 'F'; // not necessary to add metadata

            if (!create) return 'E'; // add missing metadata

            setMeta(it); // return object ID
          }

          return it[META].i;
        };

        var getWeak = function getWeak(it, create) {
          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true; // not necessary to add metadata

            if (!create) return false; // add missing metadata

            setMeta(it); // return hash weak collections IDs
          }

          return it[META].w;
        }; // add metadata on freeze-family methods calling


        var onFreeze = function onFreeze(it) {
          if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
          return it;
        };

        var meta = module.exports = {
          KEY: META,
          NEED: false,
          fastKey: fastKey,
          getWeak: getWeak,
          onFreeze: onFreeze
        };
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_microtask.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_microtask.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_microtaskJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var macrotask = __webpack_require__(
        /*! ./_task */
        "./node_modules/core-js/library/modules/_task.js").set;

        var Observer = global.MutationObserver || global.WebKitMutationObserver;
        var process = global.process;
        var Promise = global.Promise;
        var isNode = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/library/modules/_cof.js")(process) == 'process';

        module.exports = function () {
          var head, last, notify;

          var flush = function flush() {
            var parent, fn;
            if (isNode && (parent = process.domain)) parent.exit();

            while (head) {
              fn = head.fn;
              head = head.next;

              try {
                fn();
              } catch (e) {
                if (head) notify();else last = undefined;
                throw e;
              }
            }

            last = undefined;
            if (parent) parent.enter();
          }; // Node.js


          if (isNode) {
            notify = function notify() {
              process.nextTick(flush);
            }; // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339

          } else if (Observer && !(global.navigator && global.navigator.standalone)) {
            var toggle = true;
            var node = document.createTextNode('');
            new Observer(flush).observe(node, {
              characterData: true
            }); // eslint-disable-line no-new

            notify = function notify() {
              node.data = toggle = !toggle;
            }; // environments with maybe non-completely correct, but existent Promise

          } else if (Promise && Promise.resolve) {
            var promise = Promise.resolve();

            notify = function notify() {
              promise.then(flush);
            }; // for other environments - macrotask based on:
            // - setImmediate
            // - MessageChannel
            // - window.postMessag
            // - onreadystatechange
            // - setTimeout

          } else {
            notify = function notify() {
              // strange IE + webpack dev server bug - use .call(global)
              macrotask.call(global, flush);
            };
          }

          return function (fn) {
            var task = {
              fn: fn,
              next: undefined
            };
            if (last) last.next = task;

            if (!head) {
              head = task;
              notify();
            }

            last = task;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_new-promise-capability.js":
      /*!*************************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_new-promise-capability.js ***!
        \*************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_newPromiseCapabilityJs(module, exports, __webpack_require__) {
        "use strict"; // 25.4.1.5 NewPromiseCapability(C)

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/library/modules/_a-function.js");

        function PromiseCapability(C) {
          var resolve, reject;
          this.promise = new C(function ($$resolve, $$reject) {
            if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
            resolve = $$resolve;
            reject = $$reject;
          });
          this.resolve = aFunction(resolve);
          this.reject = aFunction(reject);
        }

        module.exports.f = function (C) {
          return new PromiseCapability(C);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_object-assign.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-assign.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectAssignJs(module, exports, __webpack_require__) {
        "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/library/modules/_object-keys.js");

        var gOPS = __webpack_require__(
        /*! ./_object-gops */
        "./node_modules/core-js/library/modules/_object-gops.js");

        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/library/modules/_object-pie.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/library/modules/_to-object.js");

        var IObject = __webpack_require__(
        /*! ./_iobject */
        "./node_modules/core-js/library/modules/_iobject.js");

        var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

        module.exports = !$assign || __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/library/modules/_fails.js")(function () {
          var A = {};
          var B = {}; // eslint-disable-next-line no-undef

          var S = Symbol();
          var K = 'abcdefghijklmnopqrst';
          A[S] = 7;
          K.split('').forEach(function (k) {
            B[k] = k;
          });
          return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
        }) ? function assign(target, source) {
          // eslint-disable-line no-unused-vars
          var T = toObject(target);
          var aLen = arguments.length;
          var index = 1;
          var getSymbols = gOPS.f;
          var isEnum = pIE.f;

          while (aLen > index) {
            var S = IObject(arguments[index++]);
            var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
            var length = keys.length;
            var j = 0;
            var key;

            while (length > j) {
              if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
            }
          }

          return T;
        } : $assign;
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_object-create.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-create.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectCreateJs(module, exports, __webpack_require__) {
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/library/modules/_an-object.js");

        var dPs = __webpack_require__(
        /*! ./_object-dps */
        "./node_modules/core-js/library/modules/_object-dps.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/library/modules/_enum-bug-keys.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

        var Empty = function Empty() {
          /* empty */
        };

        var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

        var _createDict = function createDict() {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = __webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/library/modules/_dom-create.js")('iframe');

          var i = enumBugKeys.length;
          var lt = '<';
          var gt = '>';
          var iframeDocument;
          iframe.style.display = 'none';

          __webpack_require__(
          /*! ./_html */
          "./node_modules/core-js/library/modules/_html.js").appendChild(iframe);

          iframe.src = 'javascript:'; // eslint-disable-line no-script-url
          // createDict = iframe.contentWindow.Object;
          // html.removeChild(iframe);

          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
          iframeDocument.close();
          _createDict = iframeDocument.F;

          while (i--) {
            delete _createDict[PROTOTYPE][enumBugKeys[i]];
          }

          return _createDict();
        };

        module.exports = Object.create || function create(O, Properties) {
          var result;

          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
          } else result = _createDict();

          return Properties === undefined ? result : dPs(result, Properties);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_object-dp.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-dp.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectDpJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/library/modules/_an-object.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "./node_modules/core-js/library/modules/_ie8-dom-define.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/library/modules/_to-primitive.js");

        var dP = Object.defineProperty;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
          } catch (e) {
            /* empty */
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_object-dps.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-dps.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectDpsJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/library/modules/_object-dp.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/library/modules/_an-object.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/library/modules/_object-keys.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          var keys = getKeys(Properties);
          var length = keys.length;
          var i = 0;
          var P;

          while (length > i) {
            dP.f(O, P = keys[i++], Properties[P]);
          }

          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_object-gopd.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-gopd.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGopdJs(module, exports, __webpack_require__) {
        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/library/modules/_object-pie.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/library/modules/_property-desc.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/library/modules/_to-iobject.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/library/modules/_to-primitive.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/library/modules/_has.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "./node_modules/core-js/library/modules/_ie8-dom-define.js");

        var gOPD = Object.getOwnPropertyDescriptor;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
          O = toIObject(O);
          P = toPrimitive(P, true);
          if (IE8_DOM_DEFINE) try {
            return gOPD(O, P);
          } catch (e) {
            /* empty */
          }
          if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
        };
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_object-gopn-ext.js":
      /*!******************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-gopn-ext.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGopnExtJs(module, exports, __webpack_require__) {
        // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/library/modules/_to-iobject.js");

        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "./node_modules/core-js/library/modules/_object-gopn.js").f;

        var toString = {}.toString;
        var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

        var getWindowNames = function getWindowNames(it) {
          try {
            return gOPN(it);
          } catch (e) {
            return windowNames.slice();
          }
        };

        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_object-gopn.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-gopn.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGopnJs(module, exports, __webpack_require__) {
        // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "./node_modules/core-js/library/modules/_object-keys-internal.js");

        var hiddenKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');

        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
          return $keys(O, hiddenKeys);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_object-gops.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-gops.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGopsJs(module, exports) {
        exports.f = Object.getOwnPropertySymbols;
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_object-gpo.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-gpo.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGpoJs(module, exports, __webpack_require__) {
        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/library/modules/_has.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/library/modules/_to-object.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

        var ObjectProto = Object.prototype;

        module.exports = Object.getPrototypeOf || function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];

          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }

          return O instanceof Object ? ObjectProto : null;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_object-keys-internal.js":
      /*!***********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-keys-internal.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectKeysInternalJs(module, exports, __webpack_require__) {
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/library/modules/_has.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/library/modules/_to-iobject.js");

        var arrayIndexOf = __webpack_require__(
        /*! ./_array-includes */
        "./node_modules/core-js/library/modules/_array-includes.js")(false);

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

        module.exports = function (object, names) {
          var O = toIObject(object);
          var i = 0;
          var result = [];
          var key;

          for (key in O) {
            if (key != IE_PROTO) has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys


          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_object-keys.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-keys.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "./node_modules/core-js/library/modules/_object-keys-internal.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/library/modules/_enum-bug-keys.js");

        module.exports = Object.keys || function keys(O) {
          return $keys(O, enumBugKeys);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_object-pie.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-pie.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectPieJs(module, exports) {
        exports.f = {}.propertyIsEnumerable;
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_object-sap.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_object-sap.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectSapJs(module, exports, __webpack_require__) {
        // most Object methods by ES6 should accept primitives
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/library/modules/_core.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/library/modules/_fails.js");

        module.exports = function (KEY, exec) {
          var fn = (core.Object || {})[KEY] || Object[KEY];
          var exp = {};
          exp[KEY] = exec(fn);
          $export($export.S + $export.F * fails(function () {
            fn(1);
          }), 'Object', exp);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_perform.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_perform.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_performJs(module, exports) {
        module.exports = function (exec) {
          try {
            return {
              e: false,
              v: exec()
            };
          } catch (e) {
            return {
              e: true,
              v: e
            };
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_promise-resolve.js":
      /*!******************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_promise-resolve.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_promiseResolveJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/library/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/library/modules/_is-object.js");

        var newPromiseCapability = __webpack_require__(
        /*! ./_new-promise-capability */
        "./node_modules/core-js/library/modules/_new-promise-capability.js");

        module.exports = function (C, x) {
          anObject(C);
          if (isObject(x) && x.constructor === C) return x;
          var promiseCapability = newPromiseCapability.f(C);
          var resolve = promiseCapability.resolve;
          resolve(x);
          return promiseCapability.promise;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_property-desc.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_property-desc.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_propertyDescJs(module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_redefine-all.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_redefine-all.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_redefineAllJs(module, exports, __webpack_require__) {
        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/library/modules/_hide.js");

        module.exports = function (target, src, safe) {
          for (var key in src) {
            if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
          }

          return target;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_redefine.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_redefine.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_redefineJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/library/modules/_hide.js");
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_set-species.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_set-species.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_setSpeciesJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/library/modules/_core.js");

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/library/modules/_object-dp.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/library/modules/_descriptors.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('species');

        module.exports = function (KEY) {
          var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
          if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
            configurable: true,
            get: function get() {
              return this;
            }
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_set-to-string-tag.js":
      /*!********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_set-to-string-tag.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_setToStringTagJs(module, exports, __webpack_require__) {
        var def = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/library/modules/_object-dp.js").f;

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/library/modules/_has.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('toStringTag');

        module.exports = function (it, tag, stat) {
          if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
            configurable: true,
            value: tag
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_shared-key.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_shared-key.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_sharedKeyJs(module, exports, __webpack_require__) {
        var shared = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/library/modules/_shared.js")('keys');

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/library/modules/_uid.js");

        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_shared.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_shared.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_sharedJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || (global[SHARED] = {});

        module.exports = function (key) {
          return store[key] || (store[key] = {});
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_species-constructor.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_species-constructor.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_speciesConstructorJs(module, exports, __webpack_require__) {
        // 7.3.20 SpeciesConstructor(O, defaultConstructor)
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/library/modules/_an-object.js");

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/library/modules/_a-function.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('species');

        module.exports = function (O, D) {
          var C = anObject(O).constructor;
          var S;
          return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_string-at.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_string-at.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_stringAtJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/library/modules/_to-integer.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/library/modules/_defined.js"); // true  -> String#at
        // false -> String#codePointAt


        module.exports = function (TO_STRING) {
          return function (that, pos) {
            var s = String(defined(that));
            var i = toInteger(pos);
            var l = s.length;
            var a, b;
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
            a = s.charCodeAt(i);
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_task.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_task.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_taskJs(module, exports, __webpack_require__) {
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/library/modules/_ctx.js");

        var invoke = __webpack_require__(
        /*! ./_invoke */
        "./node_modules/core-js/library/modules/_invoke.js");

        var html = __webpack_require__(
        /*! ./_html */
        "./node_modules/core-js/library/modules/_html.js");

        var cel = __webpack_require__(
        /*! ./_dom-create */
        "./node_modules/core-js/library/modules/_dom-create.js");

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var process = global.process;
        var setTask = global.setImmediate;
        var clearTask = global.clearImmediate;
        var MessageChannel = global.MessageChannel;
        var Dispatch = global.Dispatch;
        var counter = 0;
        var queue = {};
        var ONREADYSTATECHANGE = 'onreadystatechange';
        var defer, channel, port;

        var run = function run() {
          var id = +this; // eslint-disable-next-line no-prototype-builtins

          if (queue.hasOwnProperty(id)) {
            var fn = queue[id];
            delete queue[id];
            fn();
          }
        };

        var listener = function listener(event) {
          run.call(event.data);
        }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


        if (!setTask || !clearTask) {
          setTask = function setImmediate(fn) {
            var args = [];
            var i = 1;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            queue[++counter] = function () {
              // eslint-disable-next-line no-new-func
              invoke(typeof fn == 'function' ? fn : Function(fn), args);
            };

            defer(counter);
            return counter;
          };

          clearTask = function clearImmediate(id) {
            delete queue[id];
          }; // Node.js 0.8-


          if (__webpack_require__(
          /*! ./_cof */
          "./node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
            defer = function defer(id) {
              process.nextTick(ctx(run, id, 1));
            }; // Sphere (JS game engine) Dispatch API

          } else if (Dispatch && Dispatch.now) {
            defer = function defer(id) {
              Dispatch.now(ctx(run, id, 1));
            }; // Browsers with MessageChannel, includes WebWorkers

          } else if (MessageChannel) {
            channel = new MessageChannel();
            port = channel.port2;
            channel.port1.onmessage = listener;
            defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
            // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
          } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
            defer = function defer(id) {
              global.postMessage(id + '', '*');
            };

            global.addEventListener('message', listener, false); // IE8-
          } else if (ONREADYSTATECHANGE in cel('script')) {
            defer = function defer(id) {
              html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
                html.removeChild(this);
                run.call(id);
              };
            }; // Rest old browsers

          } else {
            defer = function defer(id) {
              setTimeout(ctx(run, id, 1), 0);
            };
          }
        }

        module.exports = {
          set: setTask,
          clear: clearTask
        };
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_to-absolute-index.js":
      /*!********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_to-absolute-index.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toAbsoluteIndexJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/library/modules/_to-integer.js");

        var max = Math.max;
        var min = Math.min;

        module.exports = function (index, length) {
          index = toInteger(index);
          return index < 0 ? max(index + length, 0) : min(index, length);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_to-integer.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_to-integer.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toIntegerJs(module, exports) {
        // 7.1.4 ToInteger
        var ceil = Math.ceil;
        var floor = Math.floor;

        module.exports = function (it) {
          return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_to-iobject.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_to-iobject.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toIobjectJs(module, exports, __webpack_require__) {
        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__(
        /*! ./_iobject */
        "./node_modules/core-js/library/modules/_iobject.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/library/modules/_defined.js");

        module.exports = function (it) {
          return IObject(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_to-length.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_to-length.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toLengthJs(module, exports, __webpack_require__) {
        // 7.1.15 ToLength
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/library/modules/_to-integer.js");

        var min = Math.min;

        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_to-object.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_to-object.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toObjectJs(module, exports, __webpack_require__) {
        // 7.1.13 ToObject(argument)
        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/library/modules/_defined.js");

        module.exports = function (it) {
          return Object(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_to-primitive.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_to-primitive.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toPrimitiveJs(module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/library/modules/_is-object.js"); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string


        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
          if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_uid.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_uid.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_uidJs(module, exports) {
        var id = 0;
        var px = Math.random();

        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_wks-define.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/_wks-define.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_wksDefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/library/modules/_core.js");

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/library/modules/_library.js");

        var wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "./node_modules/core-js/library/modules/_wks-ext.js");

        var defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/library/modules/_object-dp.js").f;

        module.exports = function (name) {
          var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
          if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
            value: wksExt.f(name)
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/_wks-ext.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/library/modules/_wks-ext.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_wksExtJs(module, exports, __webpack_require__) {
        exports.f = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js");
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/_wks.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/library/modules/_wks.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_wksJs(module, exports, __webpack_require__) {
        var store = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/library/modules/_shared.js")('wks');

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/library/modules/_uid.js");

        var Symbol = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js").Symbol;

        var USE_SYMBOL = typeof Symbol == 'function';

        var $exports = module.exports = function (name) {
          return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
        };

        $exports.store = store;
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/core.get-iterator-method.js":
      /*!**************************************************************************!*\
        !*** ./node_modules/core-js/library/modules/core.get-iterator-method.js ***!
        \**************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesCoreGetIteratorMethodJs(module, exports, __webpack_require__) {
        var classof = __webpack_require__(
        /*! ./_classof */
        "./node_modules/core-js/library/modules/_classof.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('iterator');

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/library/modules/_iterators.js");

        module.exports = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
          if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
        };
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/es6.array.from.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.array.from.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ArrayFromJs(module, exports, __webpack_require__) {
        "use strict";

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/library/modules/_ctx.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/library/modules/_to-object.js");

        var call = __webpack_require__(
        /*! ./_iter-call */
        "./node_modules/core-js/library/modules/_iter-call.js");

        var isArrayIter = __webpack_require__(
        /*! ./_is-array-iter */
        "./node_modules/core-js/library/modules/_is-array-iter.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/library/modules/_to-length.js");

        var createProperty = __webpack_require__(
        /*! ./_create-property */
        "./node_modules/core-js/library/modules/_create-property.js");

        var getIterFn = __webpack_require__(
        /*! ./core.get-iterator-method */
        "./node_modules/core-js/library/modules/core.get-iterator-method.js");

        $export($export.S + $export.F * !__webpack_require__(
        /*! ./_iter-detect */
        "./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
          Array.from(iter);
        }), 'Array', {
          // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
          from: function from(arrayLike
          /* , mapfn = undefined, thisArg = undefined */
          ) {
            var O = toObject(arrayLike);
            var C = typeof this == 'function' ? this : Array;
            var aLen = arguments.length;
            var mapfn = aLen > 1 ? arguments[1] : undefined;
            var mapping = mapfn !== undefined;
            var index = 0;
            var iterFn = getIterFn(O);
            var length, result, step, iterator;
            if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

            if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
              for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
              }
            } else {
              length = toLength(O.length);

              for (result = new C(length); length > index; index++) {
                createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
              }
            }

            result.length = index;
            return result;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es6.array.iterator.js":
      /*!********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.array.iterator.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ArrayIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var addToUnscopables = __webpack_require__(
        /*! ./_add-to-unscopables */
        "./node_modules/core-js/library/modules/_add-to-unscopables.js");

        var step = __webpack_require__(
        /*! ./_iter-step */
        "./node_modules/core-js/library/modules/_iter-step.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/library/modules/_iterators.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/library/modules/_to-iobject.js"); // 22.1.3.4 Array.prototype.entries()
        // 22.1.3.13 Array.prototype.keys()
        // 22.1.3.29 Array.prototype.values()
        // 22.1.3.30 Array.prototype[@@iterator]()


        module.exports = __webpack_require__(
        /*! ./_iter-define */
        "./node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
          this._t = toIObject(iterated); // target

          this._i = 0; // next index

          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;

          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }

          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

        Iterators.Arguments = Iterators.Array;
        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es6.object.assign.js":
      /*!*******************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.object.assign.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectAssignJs(module, exports, __webpack_require__) {
        // 19.1.3.1 Object.assign(target, source)
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js");

        $export($export.S + $export.F, 'Object', {
          assign: __webpack_require__(
          /*! ./_object-assign */
          "./node_modules/core-js/library/modules/_object-assign.js")
        });
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es6.object.define-property.js":
      /*!****************************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.object.define-property.js ***!
        \****************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectDefinePropertyJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js"); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


        $export($export.S + $export.F * !__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/library/modules/_descriptors.js"), 'Object', {
          defineProperty: __webpack_require__(
          /*! ./_object-dp */
          "./node_modules/core-js/library/modules/_object-dp.js").f
        });
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es6.object.keys.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.object.keys.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 Object.keys(O)
        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/library/modules/_to-object.js");

        var $keys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/library/modules/_object-keys.js");

        __webpack_require__(
        /*! ./_object-sap */
        "./node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
          return function keys(it) {
            return $keys(toObject(it));
          };
        });
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/es6.object.to-string.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.object.to-string.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectToStringJs(module, exports) {
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es6.promise.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.promise.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6PromiseJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/library/modules/_library.js");

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/library/modules/_ctx.js");

        var classof = __webpack_require__(
        /*! ./_classof */
        "./node_modules/core-js/library/modules/_classof.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/library/modules/_is-object.js");

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/library/modules/_a-function.js");

        var anInstance = __webpack_require__(
        /*! ./_an-instance */
        "./node_modules/core-js/library/modules/_an-instance.js");

        var forOf = __webpack_require__(
        /*! ./_for-of */
        "./node_modules/core-js/library/modules/_for-of.js");

        var speciesConstructor = __webpack_require__(
        /*! ./_species-constructor */
        "./node_modules/core-js/library/modules/_species-constructor.js");

        var task = __webpack_require__(
        /*! ./_task */
        "./node_modules/core-js/library/modules/_task.js").set;

        var microtask = __webpack_require__(
        /*! ./_microtask */
        "./node_modules/core-js/library/modules/_microtask.js")();

        var newPromiseCapabilityModule = __webpack_require__(
        /*! ./_new-promise-capability */
        "./node_modules/core-js/library/modules/_new-promise-capability.js");

        var perform = __webpack_require__(
        /*! ./_perform */
        "./node_modules/core-js/library/modules/_perform.js");

        var promiseResolve = __webpack_require__(
        /*! ./_promise-resolve */
        "./node_modules/core-js/library/modules/_promise-resolve.js");

        var PROMISE = 'Promise';
        var TypeError = global.TypeError;
        var process = global.process;
        var $Promise = global[PROMISE];
        var isNode = classof(process) == 'process';

        var empty = function empty() {
          /* empty */
        };

        var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
        var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
        var USE_NATIVE = !!function () {
          try {
            // correct subclassing with @@species support
            var promise = $Promise.resolve(1);

            var FakePromise = (promise.constructor = {})[__webpack_require__(
            /*! ./_wks */
            "./node_modules/core-js/library/modules/_wks.js")('species')] = function (exec) {
              exec(empty, empty);
            }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


            return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
          } catch (e) {
            /* empty */
          }
        }(); // helpers

        var isThenable = function isThenable(it) {
          var then;
          return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
        };

        var notify = function notify(promise, isReject) {
          if (promise._n) return;
          promise._n = true;
          var chain = promise._c;
          microtask(function () {
            var value = promise._v;
            var ok = promise._s == 1;
            var i = 0;

            var run = function run(reaction) {
              var handler = ok ? reaction.ok : reaction.fail;
              var resolve = reaction.resolve;
              var reject = reaction.reject;
              var domain = reaction.domain;
              var result, then;

              try {
                if (handler) {
                  if (!ok) {
                    if (promise._h == 2) onHandleUnhandled(promise);
                    promise._h = 1;
                  }

                  if (handler === true) result = value;else {
                    if (domain) domain.enter();
                    result = handler(value);
                    if (domain) domain.exit();
                  }

                  if (result === reaction.promise) {
                    reject(TypeError('Promise-chain cycle'));
                  } else if (then = isThenable(result)) {
                    then.call(result, resolve, reject);
                  } else resolve(result);
                } else reject(value);
              } catch (e) {
                reject(e);
              }
            };

            while (chain.length > i) {
              run(chain[i++]);
            } // variable length - can't use forEach


            promise._c = [];
            promise._n = false;
            if (isReject && !promise._h) onUnhandled(promise);
          });
        };

        var onUnhandled = function onUnhandled(promise) {
          task.call(global, function () {
            var value = promise._v;
            var unhandled = isUnhandled(promise);
            var result, handler, console;

            if (unhandled) {
              result = perform(function () {
                if (isNode) {
                  process.emit('unhandledRejection', value, promise);
                } else if (handler = global.onunhandledrejection) {
                  handler({
                    promise: promise,
                    reason: value
                  });
                } else if ((console = global.console) && console.error) {
                  console.error('Unhandled promise rejection', value);
                }
              }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

              promise._h = isNode || isUnhandled(promise) ? 2 : 1;
            }

            promise._a = undefined;
            if (unhandled && result.e) throw result.v;
          });
        };

        var isUnhandled = function isUnhandled(promise) {
          return promise._h !== 1 && (promise._a || promise._c).length === 0;
        };

        var onHandleUnhandled = function onHandleUnhandled(promise) {
          task.call(global, function () {
            var handler;

            if (isNode) {
              process.emit('rejectionHandled', promise);
            } else if (handler = global.onrejectionhandled) {
              handler({
                promise: promise,
                reason: promise._v
              });
            }
          });
        };

        var $reject = function $reject(value) {
          var promise = this;
          if (promise._d) return;
          promise._d = true;
          promise = promise._w || promise; // unwrap

          promise._v = value;
          promise._s = 2;
          if (!promise._a) promise._a = promise._c.slice();
          notify(promise, true);
        };

        var $resolve = function $resolve(value) {
          var promise = this;
          var then;
          if (promise._d) return;
          promise._d = true;
          promise = promise._w || promise; // unwrap

          try {
            if (promise === value) throw TypeError("Promise can't be resolved itself");

            if (then = isThenable(value)) {
              microtask(function () {
                var wrapper = {
                  _w: promise,
                  _d: false
                }; // wrap

                try {
                  then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
                } catch (e) {
                  $reject.call(wrapper, e);
                }
              });
            } else {
              promise._v = value;
              promise._s = 1;
              notify(promise, false);
            }
          } catch (e) {
            $reject.call({
              _w: promise,
              _d: false
            }, e); // wrap
          }
        }; // constructor polyfill


        if (!USE_NATIVE) {
          // 25.4.3.1 Promise(executor)
          $Promise = function Promise(executor) {
            anInstance(this, $Promise, PROMISE, '_h');
            aFunction(executor);
            Internal.call(this);

            try {
              executor(ctx($resolve, this, 1), ctx($reject, this, 1));
            } catch (err) {
              $reject.call(this, err);
            }
          }; // eslint-disable-next-line no-unused-vars


          Internal = function Promise(executor) {
            this._c = []; // <- awaiting reactions

            this._a = undefined; // <- checked in isUnhandled reactions

            this._s = 0; // <- state

            this._d = false; // <- done

            this._v = undefined; // <- value

            this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

            this._n = false; // <- notify
          };

          Internal.prototype = __webpack_require__(
          /*! ./_redefine-all */
          "./node_modules/core-js/library/modules/_redefine-all.js")($Promise.prototype, {
            // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
            then: function then(onFulfilled, onRejected) {
              var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
              reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
              reaction.fail = typeof onRejected == 'function' && onRejected;
              reaction.domain = isNode ? process.domain : undefined;

              this._c.push(reaction);

              if (this._a) this._a.push(reaction);
              if (this._s) notify(this, false);
              return reaction.promise;
            },
            // 25.4.5.1 Promise.prototype.catch(onRejected)
            'catch': function _catch(onRejected) {
              return this.then(undefined, onRejected);
            }
          });

          OwnPromiseCapability = function OwnPromiseCapability() {
            var promise = new Internal();
            this.promise = promise;
            this.resolve = ctx($resolve, promise, 1);
            this.reject = ctx($reject, promise, 1);
          };

          newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
            return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Promise: $Promise
        });

        __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/library/modules/_set-to-string-tag.js")($Promise, PROMISE);

        __webpack_require__(
        /*! ./_set-species */
        "./node_modules/core-js/library/modules/_set-species.js")(PROMISE);

        Wrapper = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/library/modules/_core.js")[PROMISE]; // statics

        $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
          // 25.4.4.5 Promise.reject(r)
          reject: function reject(r) {
            var capability = newPromiseCapability(this);
            var $$reject = capability.reject;
            $$reject(r);
            return capability.promise;
          }
        });
        $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
          // 25.4.4.6 Promise.resolve(x)
          resolve: function resolve(x) {
            return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
          }
        });
        $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(
        /*! ./_iter-detect */
        "./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
          $Promise.all(iter)['catch'](empty);
        })), PROMISE, {
          // 25.4.4.1 Promise.all(iterable)
          all: function all(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform(function () {
              var values = [];
              var index = 0;
              var remaining = 1;
              forOf(iterable, false, function (promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function (value) {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[$index] = value;
                  --remaining || resolve(values);
                }, reject);
              });
              --remaining || resolve(values);
            });
            if (result.e) reject(result.v);
            return capability.promise;
          },
          // 25.4.4.4 Promise.race(iterable)
          race: function race(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var reject = capability.reject;
            var result = perform(function () {
              forOf(iterable, false, function (promise) {
                C.resolve(promise).then(capability.resolve, reject);
              });
            });
            if (result.e) reject(result.v);
            return capability.promise;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es6.string.iterator.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.string.iterator.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6StringIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var $at = __webpack_require__(
        /*! ./_string-at */
        "./node_modules/core-js/library/modules/_string-at.js")(true); // 21.1.3.27 String.prototype[@@iterator]()


        __webpack_require__(
        /*! ./_iter-define */
        "./node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
          this._t = String(iterated); // target

          this._i = 0; // next index
          // 21.1.5.2.1 %StringIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var index = this._i;
          var point;
          if (index >= O.length) return {
            value: undefined,
            done: true
          };
          point = $at(O, index);
          this._i += point.length;
          return {
            value: point,
            done: false
          };
        });
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/es6.symbol.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es6.symbol.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6SymbolJs(module, exports, __webpack_require__) {
        "use strict"; // ECMAScript 6 symbols shim

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/library/modules/_has.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/library/modules/_descriptors.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/library/modules/_redefine.js");

        var META = __webpack_require__(
        /*! ./_meta */
        "./node_modules/core-js/library/modules/_meta.js").KEY;

        var $fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/library/modules/_fails.js");

        var shared = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/library/modules/_shared.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/library/modules/_set-to-string-tag.js");

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/library/modules/_uid.js");

        var wks = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js");

        var wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "./node_modules/core-js/library/modules/_wks-ext.js");

        var wksDefine = __webpack_require__(
        /*! ./_wks-define */
        "./node_modules/core-js/library/modules/_wks-define.js");

        var enumKeys = __webpack_require__(
        /*! ./_enum-keys */
        "./node_modules/core-js/library/modules/_enum-keys.js");

        var isArray = __webpack_require__(
        /*! ./_is-array */
        "./node_modules/core-js/library/modules/_is-array.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/library/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/library/modules/_is-object.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/library/modules/_to-iobject.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/library/modules/_to-primitive.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/library/modules/_property-desc.js");

        var _create = __webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/library/modules/_object-create.js");

        var gOPNExt = __webpack_require__(
        /*! ./_object-gopn-ext */
        "./node_modules/core-js/library/modules/_object-gopn-ext.js");

        var $GOPD = __webpack_require__(
        /*! ./_object-gopd */
        "./node_modules/core-js/library/modules/_object-gopd.js");

        var $DP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/library/modules/_object-dp.js");

        var $keys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/library/modules/_object-keys.js");

        var gOPD = $GOPD.f;
        var dP = $DP.f;
        var gOPN = gOPNExt.f;
        var $Symbol = global.Symbol;
        var $JSON = global.JSON;

        var _stringify = $JSON && $JSON.stringify;

        var PROTOTYPE = 'prototype';
        var HIDDEN = wks('_hidden');
        var TO_PRIMITIVE = wks('toPrimitive');
        var isEnum = {}.propertyIsEnumerable;
        var SymbolRegistry = shared('symbol-registry');
        var AllSymbols = shared('symbols');
        var OPSymbols = shared('op-symbols');
        var ObjectProto = Object[PROTOTYPE];
        var USE_NATIVE = typeof $Symbol == 'function';
        var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

        var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

        var setSymbolDesc = DESCRIPTORS && $fails(function () {
          return _create(dP({}, 'a', {
            get: function get() {
              return dP(this, 'a', {
                value: 7
              }).a;
            }
          })).a != 7;
        }) ? function (it, key, D) {
          var protoDesc = gOPD(ObjectProto, key);
          if (protoDesc) delete ObjectProto[key];
          dP(it, key, D);
          if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
        } : dP;

        var wrap = function wrap(tag) {
          var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

          sym._k = tag;
          return sym;
        };

        var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
          return typeof it == 'symbol';
        } : function (it) {
          return it instanceof $Symbol;
        };

        var $defineProperty = function defineProperty(it, key, D) {
          if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
          anObject(it);
          key = toPrimitive(key, true);
          anObject(D);

          if (has(AllSymbols, key)) {
            if (!D.enumerable) {
              if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
              it[HIDDEN][key] = true;
            } else {
              if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
              D = _create(D, {
                enumerable: createDesc(0, false)
              });
            }

            return setSymbolDesc(it, key, D);
          }

          return dP(it, key, D);
        };

        var $defineProperties = function defineProperties(it, P) {
          anObject(it);
          var keys = enumKeys(P = toIObject(P));
          var i = 0;
          var l = keys.length;
          var key;

          while (l > i) {
            $defineProperty(it, key = keys[i++], P[key]);
          }

          return it;
        };

        var $create = function create(it, P) {
          return P === undefined ? _create(it) : $defineProperties(_create(it), P);
        };

        var $propertyIsEnumerable = function propertyIsEnumerable(key) {
          var E = isEnum.call(this, key = toPrimitive(key, true));
          if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
          return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
        };

        var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
          it = toIObject(it);
          key = toPrimitive(key, true);
          if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
          var D = gOPD(it, key);
          if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
          return D;
        };

        var $getOwnPropertyNames = function getOwnPropertyNames(it) {
          var names = gOPN(toIObject(it));
          var result = [];
          var i = 0;
          var key;

          while (names.length > i) {
            if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
          }

          return result;
        };

        var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
          var IS_OP = it === ObjectProto;
          var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
          var result = [];
          var i = 0;
          var key;

          while (names.length > i) {
            if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
          }

          return result;
        }; // 19.4.1.1 Symbol([description])


        if (!USE_NATIVE) {
          $Symbol = function Symbol() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
            var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

            var $set = function $set(value) {
              if (this === ObjectProto) $set.call(OPSymbols, value);
              if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
              setSymbolDesc(this, tag, createDesc(1, value));
            };

            if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
              configurable: true,
              set: $set
            });
            return wrap(tag);
          };

          redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return this._k;
          });
          $GOPD.f = $getOwnPropertyDescriptor;
          $DP.f = $defineProperty;
          __webpack_require__(
          /*! ./_object-gopn */
          "./node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
          __webpack_require__(
          /*! ./_object-pie */
          "./node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
          __webpack_require__(
          /*! ./_object-gops */
          "./node_modules/core-js/library/modules/_object-gops.js").f = $getOwnPropertySymbols;

          if (DESCRIPTORS && !__webpack_require__(
          /*! ./_library */
          "./node_modules/core-js/library/modules/_library.js")) {
            redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
          }

          wksExt.f = function (name) {
            return wrap(wks(name));
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Symbol: $Symbol
        });

        for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
        'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
          wks(es6Symbols[j++]);
        }

        for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
          wksDefine(wellKnownSymbols[k++]);
        }

        $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
          // 19.4.2.1 Symbol.for(key)
          'for': function _for(key) {
            return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
          },
          // 19.4.2.5 Symbol.keyFor(sym)
          keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

            for (var key in SymbolRegistry) {
              if (SymbolRegistry[key] === sym) return key;
            }
          },
          useSetter: function useSetter() {
            setter = true;
          },
          useSimple: function useSimple() {
            setter = false;
          }
        });
        $export($export.S + $export.F * !USE_NATIVE, 'Object', {
          // 19.1.2.2 Object.create(O [, Properties])
          create: $create,
          // 19.1.2.4 Object.defineProperty(O, P, Attributes)
          defineProperty: $defineProperty,
          // 19.1.2.3 Object.defineProperties(O, Properties)
          defineProperties: $defineProperties,
          // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
          getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
          // 19.1.2.7 Object.getOwnPropertyNames(O)
          getOwnPropertyNames: $getOwnPropertyNames,
          // 19.1.2.8 Object.getOwnPropertySymbols(O)
          getOwnPropertySymbols: $getOwnPropertySymbols
        }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

        $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
          var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
          // WebKit converts symbol values to JSON as null
          // V8 throws on boxed symbols

          return _stringify([S]) != '[null]' || _stringify({
            a: S
          }) != '{}' || _stringify(Object(S)) != '{}';
        })), 'JSON', {
          stringify: function stringify(it) {
            var args = [it];
            var i = 1;
            var replacer, $replacer;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            $replacer = replacer = args[1];
            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

            if (!isArray(replacer)) replacer = function replacer(key, value) {
              if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
              if (!isSymbol(value)) return value;
            };
            args[1] = replacer;
            return _stringify.apply($JSON, args);
          }
        }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

        $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

        setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

        setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

        setToStringTag(global.JSON, 'JSON', true);
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es7.promise.finally.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es7.promise.finally.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs7PromiseFinallyJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/proposal-promise-finally

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/library/modules/_core.js");

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var speciesConstructor = __webpack_require__(
        /*! ./_species-constructor */
        "./node_modules/core-js/library/modules/_species-constructor.js");

        var promiseResolve = __webpack_require__(
        /*! ./_promise-resolve */
        "./node_modules/core-js/library/modules/_promise-resolve.js");

        $export($export.P + $export.R, 'Promise', {
          'finally': function _finally(onFinally) {
            var C = speciesConstructor(this, core.Promise || global.Promise);
            var isFunction = typeof onFinally == 'function';
            return this.then(isFunction ? function (x) {
              return promiseResolve(C, onFinally()).then(function () {
                return x;
              });
            } : onFinally, isFunction ? function (e) {
              return promiseResolve(C, onFinally()).then(function () {
                throw e;
              });
            } : onFinally);
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es7.promise.try.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es7.promise.try.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs7PromiseTryJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/proposal-promise-try

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/library/modules/_export.js");

        var newPromiseCapability = __webpack_require__(
        /*! ./_new-promise-capability */
        "./node_modules/core-js/library/modules/_new-promise-capability.js");

        var perform = __webpack_require__(
        /*! ./_perform */
        "./node_modules/core-js/library/modules/_perform.js");

        $export($export.S, 'Promise', {
          'try': function _try(callbackfn) {
            var promiseCapability = newPromiseCapability.f(this);
            var result = perform(callbackfn);
            (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
            return promiseCapability.promise;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
      /*!***************************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es7.symbol.async-iterator.js ***!
        \***************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs7SymbolAsyncIteratorJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./_wks-define */
        "./node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/es7.symbol.observable.js":
      /*!***********************************************************************!*\
        !*** ./node_modules/core-js/library/modules/es7.symbol.observable.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs7SymbolObservableJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./_wks-define */
        "./node_modules/core-js/library/modules/_wks-define.js")('observable');
        /***/

      },

      /***/
      "./node_modules/core-js/library/modules/web.dom.iterable.js":
      /*!******************************************************************!*\
        !*** ./node_modules/core-js/library/modules/web.dom.iterable.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesWebDomIterableJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./es6.array.iterator */
        "./node_modules/core-js/library/modules/es6.array.iterator.js");

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/library/modules/_global.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/library/modules/_hide.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/library/modules/_iterators.js");

        var TO_STRING_TAG = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/library/modules/_wks.js")('toStringTag');

        var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

        for (var i = 0; i < DOMIterables.length; i++) {
          var NAME = DOMIterables[i];
          var Collection = global[NAME];
          var proto = Collection && Collection.prototype;
          if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = Iterators.Array;
        }
        /***/

      },

      /***/
      "./node_modules/redux-saga/es/effects.js":
      /*!***********************************************!*\
        !*** ./node_modules/redux-saga/es/effects.js ***!
        \***********************************************/

      /*! exports provided: take, takem, put, all, race, call, apply, cps, fork, spawn, join, cancel, select, actionChannel, cancelled, flush, getContext, setContext, takeEvery, takeLatest, throttle */

      /***/
      function node_modulesReduxSagaEsEffectsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _internal_io__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./internal/io */
        "./node_modules/redux-saga/es/internal/io.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "take", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["take"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takem", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["takem"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "put", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["put"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "all", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["all"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "race", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["race"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "call", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["call"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "apply", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["apply"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "cps", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cps"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "fork", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["fork"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "spawn", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["spawn"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "join", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["join"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "cancel", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cancel"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "select", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["select"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "actionChannel", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["actionChannel"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "cancelled", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cancelled"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "flush", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["flush"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "getContext", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["getContext"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "setContext", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["setContext"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takeEvery", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["takeEvery"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takeLatest", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["takeLatest"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "throttle", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["throttle"];
        });
        /***/

      },

      /***/
      "./node_modules/redux-saga/es/internal/buffers.js":
      /*!********************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/buffers.js ***!
        \********************************************************/

      /*! exports provided: BUFFER_OVERFLOW, buffers */

      /***/
      function node_modulesReduxSagaEsInternalBuffersJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "BUFFER_OVERFLOW", function () {
          return BUFFER_OVERFLOW;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "buffers", function () {
          return buffers;
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./utils */
        "./node_modules/redux-saga/es/internal/utils.js");

        var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
        var ON_OVERFLOW_THROW = 1;
        var ON_OVERFLOW_DROP = 2;
        var ON_OVERFLOW_SLIDE = 3;
        var ON_OVERFLOW_EXPAND = 4;
        var zeroBuffer = {
          isEmpty: _utils__WEBPACK_IMPORTED_MODULE_0__["kTrue"],
          put: _utils__WEBPACK_IMPORTED_MODULE_0__["noop"],
          take: _utils__WEBPACK_IMPORTED_MODULE_0__["noop"]
        };

        function ringBuffer() {
          var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
          var overflowAction = arguments[1];
          var arr = new Array(limit);
          var length = 0;
          var pushIndex = 0;
          var popIndex = 0;

          var push = function push(it) {
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            length++;
          };

          var take = function take() {
            if (length != 0) {
              var it = arr[popIndex];
              arr[popIndex] = null;
              length--;
              popIndex = (popIndex + 1) % limit;
              return it;
            }
          };

          var flush = function flush() {
            var items = [];

            while (length) {
              items.push(take());
            }

            return items;
          };

          return {
            isEmpty: function isEmpty() {
              return length == 0;
            },
            put: function put(it) {
              if (length < limit) {
                push(it);
              } else {
                var doubledLimit = void 0;

                switch (overflowAction) {
                  case ON_OVERFLOW_THROW:
                    throw new Error(BUFFER_OVERFLOW);

                  case ON_OVERFLOW_SLIDE:
                    arr[pushIndex] = it;
                    pushIndex = (pushIndex + 1) % limit;
                    popIndex = pushIndex;
                    break;

                  case ON_OVERFLOW_EXPAND:
                    doubledLimit = 2 * limit;
                    arr = flush();
                    length = arr.length;
                    pushIndex = arr.length;
                    popIndex = 0;
                    arr.length = doubledLimit;
                    limit = doubledLimit;
                    push(it);
                    break;

                  default: // DROP

                }
              }
            },
            take: take,
            flush: flush
          };
        }

        var buffers = {
          none: function none() {
            return zeroBuffer;
          },
          fixed: function fixed(limit) {
            return ringBuffer(limit, ON_OVERFLOW_THROW);
          },
          dropping: function dropping(limit) {
            return ringBuffer(limit, ON_OVERFLOW_DROP);
          },
          sliding: function sliding(limit) {
            return ringBuffer(limit, ON_OVERFLOW_SLIDE);
          },
          expanding: function expanding(initialSize) {
            return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
          }
        };
        /***/
      },

      /***/
      "./node_modules/redux-saga/es/internal/channel.js":
      /*!********************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/channel.js ***!
        \********************************************************/

      /*! exports provided: END, isEnd, emitter, INVALID_BUFFER, UNDEFINED_INPUT_ERROR, channel, eventChannel, stdChannel */

      /***/
      function node_modulesReduxSagaEsInternalChannelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "END", function () {
          return END;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "isEnd", function () {
          return isEnd;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "emitter", function () {
          return emitter;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "INVALID_BUFFER", function () {
          return INVALID_BUFFER;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "UNDEFINED_INPUT_ERROR", function () {
          return UNDEFINED_INPUT_ERROR;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "channel", function () {
          return channel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "eventChannel", function () {
          return eventChannel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "stdChannel", function () {
          return stdChannel;
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./utils */
        "./node_modules/redux-saga/es/internal/utils.js");
        /* harmony import */


        var _buffers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./buffers */
        "./node_modules/redux-saga/es/internal/buffers.js");
        /* harmony import */


        var _scheduler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./scheduler */
        "./node_modules/redux-saga/es/internal/scheduler.js");

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
        var END = {
          type: CHANNEL_END_TYPE
        };

        var isEnd = function isEnd(a) {
          return a && a.type === CHANNEL_END_TYPE;
        };

        function emitter() {
          var subscribers = [];

          function subscribe(sub) {
            subscribers.push(sub);
            return function () {
              return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["remove"])(subscribers, sub);
            };
          }

          function emit(item) {
            var arr = subscribers.slice();

            for (var i = 0, len = arr.length; i < len; i++) {
              arr[i](item);
            }
          }

          return {
            subscribe: subscribe,
            emit: emit
          };
        }

        var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
        var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

        if (true) {
          UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
        }

        function channel() {
          var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers__WEBPACK_IMPORTED_MODULE_1__["buffers"].fixed();
          var closed = false;
          var takers = [];
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].buffer, INVALID_BUFFER);

          function checkForbiddenStates() {
            if (closed && takers.length) {
              throw Object(_utils__WEBPACK_IMPORTED_MODULE_0__["internalErr"])('Cannot have a closed channel with pending takers');
            }

            if (takers.length && !buffer.isEmpty()) {
              throw Object(_utils__WEBPACK_IMPORTED_MODULE_0__["internalErr"])('Cannot have pending takers with non empty buffer');
            }
          }

          function put(input) {
            checkForbiddenStates();
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(input, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, UNDEFINED_INPUT_ERROR);

            if (closed) {
              return;
            }

            if (!takers.length) {
              return buffer.put(input);
            }

            for (var i = 0; i < takers.length; i++) {
              var cb = takers[i];

              if (!cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]] || cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]](input)) {
                takers.splice(i, 1);
                return cb(input);
              }
            }
          }

          function take(cb) {
            checkForbiddenStates();
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(cb, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.take's callback must be a function");

            if (closed && buffer.isEmpty()) {
              cb(END);
            } else if (!buffer.isEmpty()) {
              cb(buffer.take());
            } else {
              takers.push(cb);

              cb.cancel = function () {
                return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["remove"])(takers, cb);
              };
            }
          }

          function flush(cb) {
            checkForbiddenStates(); // TODO: check if some new state should be forbidden now

            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(cb, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.flush' callback must be a function");

            if (closed && buffer.isEmpty()) {
              cb(END);
              return;
            }

            cb(buffer.flush());
          }

          function close() {
            checkForbiddenStates();

            if (!closed) {
              closed = true;

              if (takers.length) {
                var arr = takers;
                takers = [];

                for (var i = 0, len = arr.length; i < len; i++) {
                  arr[i](END);
                }
              }
            }
          }

          return {
            take: take,
            put: put,
            flush: flush,
            close: close,

            get __takers__() {
              return takers;
            },

            get __closed__() {
              return closed;
            }

          };
        }

        function eventChannel(subscribe) {
          var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers__WEBPACK_IMPORTED_MODULE_1__["buffers"].none();
          var matcher = arguments[2];
          /**
            should be if(typeof matcher !== undefined) instead?
            see PR #273 for a background discussion
          **/

          if (arguments.length > 2) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(matcher, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, 'Invalid match function passed to eventChannel');
          }

          var chan = channel(buffer);

          var close = function close() {
            if (!chan.__closed__) {
              if (unsubscribe) {
                unsubscribe();
              }

              chan.close();
            }
          };

          var unsubscribe = subscribe(function (input) {
            if (isEnd(input)) {
              close();
              return;
            }

            if (matcher && !matcher(input)) {
              return;
            }

            chan.put(input);
          });

          if (chan.__closed__) {
            unsubscribe();
          }

          if (!_utils__WEBPACK_IMPORTED_MODULE_0__["is"].func(unsubscribe)) {
            throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
          }

          return {
            take: chan.take,
            flush: chan.flush,
            close: close
          };
        }

        function stdChannel(subscribe) {
          var chan = eventChannel(function (cb) {
            return subscribe(function (input) {
              if (input[_utils__WEBPACK_IMPORTED_MODULE_0__["SAGA_ACTION"]]) {
                cb(input);
                return;
              }

              Object(_scheduler__WEBPACK_IMPORTED_MODULE_2__["asap"])(function () {
                return cb(input);
              });
            });
          });
          return _extends({}, chan, {
            take: function take(cb, matcher) {
              if (arguments.length > 1) {
                Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(matcher, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.take's matcher argument must be a function");
                cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]] = matcher;
              }

              chan.take(cb);
            }
          });
        }
        /***/

      },

      /***/
      "./node_modules/redux-saga/es/internal/io.js":
      /*!***************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/io.js ***!
        \***************************************************/

      /*! exports provided: detach, take, takem, put, all, race, call, apply, cps, fork, spawn, join, cancel, select, actionChannel, cancelled, flush, getContext, setContext, takeEvery, takeLatest, throttle, asEffect */

      /***/
      function node_modulesReduxSagaEsInternalIoJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "detach", function () {
          return detach;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "take", function () {
          return take;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takem", function () {
          return takem;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "put", function () {
          return put;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "all", function () {
          return all;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "race", function () {
          return race;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "call", function () {
          return call;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "apply", function () {
          return apply;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cps", function () {
          return cps;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "fork", function () {
          return fork;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "spawn", function () {
          return spawn;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "join", function () {
          return join;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cancel", function () {
          return cancel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "select", function () {
          return select;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "actionChannel", function () {
          return actionChannel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cancelled", function () {
          return cancelled;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "flush", function () {
          return flush;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getContext", function () {
          return getContext;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "setContext", function () {
          return setContext;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takeEvery", function () {
          return takeEvery;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takeLatest", function () {
          return takeLatest;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "throttle", function () {
          return throttle;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "asEffect", function () {
          return asEffect;
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./utils */
        "./node_modules/redux-saga/es/internal/utils.js");
        /* harmony import */


        var _sagaHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./sagaHelpers */
        "./node_modules/redux-saga/es/internal/sagaHelpers/index.js");

        var IO =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["sym"])('IO');
        var TAKE = 'TAKE';
        var PUT = 'PUT';
        var ALL = 'ALL';
        var RACE = 'RACE';
        var CALL = 'CALL';
        var CPS = 'CPS';
        var FORK = 'FORK';
        var JOIN = 'JOIN';
        var CANCEL = 'CANCEL';
        var SELECT = 'SELECT';
        var ACTION_CHANNEL = 'ACTION_CHANNEL';
        var CANCELLED = 'CANCELLED';
        var FLUSH = 'FLUSH';
        var GET_CONTEXT = 'GET_CONTEXT';
        var SET_CONTEXT = 'SET_CONTEXT';
        var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

        var effect = function effect(type, payload) {
          var _ref;

          return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
        };

        var detach = function detach(eff) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(asEffect.fork(eff), _utils__WEBPACK_IMPORTED_MODULE_0__["is"].object, 'detach(eff): argument must be a fork effect');
          eff[FORK].detached = true;
          return eff;
        };

        function take() {
          var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

          if (arguments.length) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(arguments[0], _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
          }

          if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].pattern(patternOrChannel)) {
            return effect(TAKE, {
              pattern: patternOrChannel
            });
          }

          if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel(patternOrChannel)) {
            return effect(TAKE, {
              channel: patternOrChannel
            });
          }

          throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
        }

        take.maybe = function () {
          var eff = take.apply(undefined, arguments);
          eff[TAKE].maybe = true;
          return eff;
        };

        var takem =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["deprecate"])(take.maybe,
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["updateIncentive"])('takem', 'take.maybe'));

        function put(channel, action) {
          if (arguments.length > 1) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(channel, action): argument channel is undefined');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(action, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(channel, action): argument action is undefined');
          } else {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(action): argument action is undefined');
            action = channel;
            channel = null;
          }

          return effect(PUT, {
            channel: channel,
            action: action
          });
        }

        put.resolve = function () {
          var eff = put.apply(undefined, arguments);
          eff[PUT].resolve = true;
          return eff;
        };

        put.sync =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["deprecate"])(put.resolve,
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["updateIncentive"])('put.sync', 'put.resolve'));

        function all(effects) {
          return effect(ALL, effects);
        }

        function race(effects) {
          return effect(RACE, effects);
        }

        function getFnCallDesc(meth, fn, args) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(fn, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, meth + ': argument fn is undefined');
          var context = null;

          if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].array(fn)) {
            var _fn = fn;
            context = _fn[0];
            fn = _fn[1];
          } else if (fn.fn) {
            var _fn2 = fn;
            context = _fn2.context;
            fn = _fn2.fn;
          }

          if (context && _utils__WEBPACK_IMPORTED_MODULE_0__["is"].string(fn) && _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func(context[fn])) {
            fn = context[fn];
          }

          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(fn, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, meth + ': argument ' + fn + ' is not a function');
          return {
            context: context,
            fn: fn,
            args: args
          };
        }

        function call(fn) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          return effect(CALL, getFnCallDesc('call', fn, args));
        }

        function apply(context, fn) {
          var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          return effect(CALL, getFnCallDesc('apply', {
            context: context,
            fn: fn
          }, args));
        }

        function cps(fn) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return effect(CPS, getFnCallDesc('cps', fn, args));
        }

        function fork(fn) {
          for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }

          return effect(FORK, getFnCallDesc('fork', fn, args));
        }

        function spawn(fn) {
          for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            args[_key4 - 1] = arguments[_key4];
          }

          return detach(fork.apply(undefined, [fn].concat(args)));
        }

        function join() {
          for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            tasks[_key5] = arguments[_key5];
          }

          if (tasks.length > 1) {
            return all(tasks.map(function (t) {
              return join(t);
            }));
          }

          var task = tasks[0];
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'join(task): argument task is undefined');
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
          return effect(JOIN, task);
        }

        function cancel() {
          for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            tasks[_key6] = arguments[_key6];
          }

          if (tasks.length > 1) {
            return all(tasks.map(function (t) {
              return cancel(t);
            }));
          }

          var task = tasks[0];

          if (tasks.length === 1) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'cancel(task): argument task is undefined');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
          }

          return effect(CANCEL, task || _utils__WEBPACK_IMPORTED_MODULE_0__["SELF_CANCELLATION"]);
        }

        function select(selector) {
          for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
            args[_key7 - 1] = arguments[_key7];
          }

          if (arguments.length === 0) {
            selector = _utils__WEBPACK_IMPORTED_MODULE_0__["ident"];
          } else {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(selector, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'select(selector,[...]): argument selector is undefined');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(selector, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
          }

          return effect(SELECT, {
            selector: selector,
            args: args
          });
        }
        /**
          channel(pattern, [buffer])    => creates an event channel for store actions
        **/


        function actionChannel(pattern, buffer) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(pattern, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');

          if (arguments.length > 1) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
          }

          return effect(ACTION_CHANNEL, {
            pattern: pattern,
            buffer: buffer
          });
        }

        function cancelled() {
          return effect(CANCELLED, {});
        }

        function flush(channel) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
          return effect(FLUSH, channel);
        }

        function getContext(prop) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(prop, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].string, 'getContext(prop): argument ' + prop + ' is not a string');
          return effect(GET_CONTEXT, prop);
        }

        function setContext(props) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(props, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].object, Object(_utils__WEBPACK_IMPORTED_MODULE_0__["createSetContextWarning"])(null, props));
          return effect(SET_CONTEXT, props);
        }

        function takeEvery(patternOrChannel, worker) {
          for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
            args[_key8 - 2] = arguments[_key8];
          }

          return fork.apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["takeEveryHelper"], patternOrChannel, worker].concat(args));
        }

        function takeLatest(patternOrChannel, worker) {
          for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
            args[_key9 - 2] = arguments[_key9];
          }

          return fork.apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["takeLatestHelper"], patternOrChannel, worker].concat(args));
        }

        function throttle(ms, pattern, worker) {
          for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
            args[_key10 - 3] = arguments[_key10];
          }

          return fork.apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["throttleHelper"], ms, pattern, worker].concat(args));
        }

        var createAsEffectType = function createAsEffectType(type) {
          return function (effect) {
            return effect && effect[IO] && effect[type];
          };
        };

        var asEffect = {
          take:
          /*#__PURE__*/
          createAsEffectType(TAKE),
          put:
          /*#__PURE__*/
          createAsEffectType(PUT),
          all:
          /*#__PURE__*/
          createAsEffectType(ALL),
          race:
          /*#__PURE__*/
          createAsEffectType(RACE),
          call:
          /*#__PURE__*/
          createAsEffectType(CALL),
          cps:
          /*#__PURE__*/
          createAsEffectType(CPS),
          fork:
          /*#__PURE__*/
          createAsEffectType(FORK),
          join:
          /*#__PURE__*/
          createAsEffectType(JOIN),
          cancel:
          /*#__PURE__*/
          createAsEffectType(CANCEL),
          select:
          /*#__PURE__*/
          createAsEffectType(SELECT),
          actionChannel:
          /*#__PURE__*/
          createAsEffectType(ACTION_CHANNEL),
          cancelled:
          /*#__PURE__*/
          createAsEffectType(CANCELLED),
          flush:
          /*#__PURE__*/
          createAsEffectType(FLUSH),
          getContext:
          /*#__PURE__*/
          createAsEffectType(GET_CONTEXT),
          setContext:
          /*#__PURE__*/
          createAsEffectType(SET_CONTEXT)
        };
        /***/
      },

      /***/
      "./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js":
      /*!************************************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js ***!
        \************************************************************************/

      /*! exports provided: qEnd, safeName, default */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersFsmIteratorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "qEnd", function () {
          return qEnd;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "safeName", function () {
          return safeName;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return fsmIterator;
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ../utils */
        "./node_modules/redux-saga/es/internal/utils.js");

        var done = {
          done: true,
          value: undefined
        };
        var qEnd = {};

        function safeName(patternOrChannel) {
          if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel(patternOrChannel)) {
            return 'channel';
          } else if (Array.isArray(patternOrChannel)) {
            return String(patternOrChannel.map(function (entry) {
              return String(entry);
            }));
          } else {
            return String(patternOrChannel);
          }
        }

        function fsmIterator(fsm, q0) {
          var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
          var updateState = void 0,
              qNext = q0;

          function next(arg, error) {
            if (qNext === qEnd) {
              return done;
            }

            if (error) {
              qNext = qEnd;
              throw error;
            } else {
              updateState && updateState(arg);

              var _fsm$qNext = fsm[qNext](),
                  q = _fsm$qNext[0],
                  output = _fsm$qNext[1],
                  _updateState = _fsm$qNext[2];

              qNext = q;
              updateState = _updateState;
              return qNext === qEnd ? done : output;
            }
          }

          return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["makeIterator"])(next, function (error) {
            return next(null, error);
          }, name, true);
        }
        /***/

      },

      /***/
      "./node_modules/redux-saga/es/internal/sagaHelpers/index.js":
      /*!******************************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/sagaHelpers/index.js ***!
        \******************************************************************/

      /*! exports provided: takeEvery, takeLatest, throttle, takeEveryHelper, takeLatestHelper, throttleHelper */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takeEvery", function () {
          return takeEvery;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takeLatest", function () {
          return takeLatest;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "throttle", function () {
          return throttle;
        });
        /* harmony import */


        var _takeEvery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./takeEvery */
        "./node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takeEveryHelper", function () {
          return _takeEvery__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /* harmony import */


        var _takeLatest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./takeLatest */
        "./node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takeLatestHelper", function () {
          return _takeLatest__WEBPACK_IMPORTED_MODULE_1__["default"];
        });
        /* harmony import */


        var _throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./throttle */
        "./node_modules/redux-saga/es/internal/sagaHelpers/throttle.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "throttleHelper", function () {
          return _throttle__WEBPACK_IMPORTED_MODULE_2__["default"];
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../utils */
        "./node_modules/redux-saga/es/internal/utils.js");

        var deprecationWarning = function deprecationWarning(helperName) {
          return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
        };

        var takeEvery =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_takeEvery__WEBPACK_IMPORTED_MODULE_0__["default"],
        /*#__PURE__*/
        deprecationWarning('takeEvery'));
        var takeLatest =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_takeLatest__WEBPACK_IMPORTED_MODULE_1__["default"],
        /*#__PURE__*/
        deprecationWarning('takeLatest'));
        var throttle =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_throttle__WEBPACK_IMPORTED_MODULE_2__["default"],
        /*#__PURE__*/
        deprecationWarning('throttle'));
        /***/
      },

      /***/
      "./node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js ***!
        \**********************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersTakeEveryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return takeEvery;
        });
        /* harmony import */


        var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./fsmIterator */
        "./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
        /* harmony import */


        var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../io */
        "./node_modules/redux-saga/es/internal/io.js");
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../channel */
        "./node_modules/redux-saga/es/internal/channel.js");

        function takeEvery(patternOrChannel, worker) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          var yTake = {
            done: false,
            value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(patternOrChannel)
          };

          var yFork = function yFork(ac) {
            return {
              done: false,
              value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac]))
            };
          };

          var action = void 0,
              setAction = function setAction(ac) {
            return action = ac;
          };

          return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
            q1: function q1() {
              return ['q2', yTake, setAction];
            },
            q2: function q2() {
              return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : ['q1', yFork(action)];
            }
          }, 'q1', 'takeEvery(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(patternOrChannel) + ', ' + worker.name + ')');
        }
        /***/

      },

      /***/
      "./node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js":
      /*!***********************************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js ***!
        \***********************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersTakeLatestJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return takeLatest;
        });
        /* harmony import */


        var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./fsmIterator */
        "./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
        /* harmony import */


        var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../io */
        "./node_modules/redux-saga/es/internal/io.js");
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../channel */
        "./node_modules/redux-saga/es/internal/channel.js");

        function takeLatest(patternOrChannel, worker) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          var yTake = {
            done: false,
            value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(patternOrChannel)
          };

          var yFork = function yFork(ac) {
            return {
              done: false,
              value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac]))
            };
          };

          var yCancel = function yCancel(task) {
            return {
              done: false,
              value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["cancel"])(task)
            };
          };

          var task = void 0,
              action = void 0;

          var setTask = function setTask(t) {
            return task = t;
          };

          var setAction = function setAction(ac) {
            return action = ac;
          };

          return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
            q1: function q1() {
              return ['q2', yTake, setAction];
            },
            q2: function q2() {
              return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
            },
            q3: function q3() {
              return ['q1', yFork(action), setTask];
            }
          }, 'q1', 'takeLatest(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(patternOrChannel) + ', ' + worker.name + ')');
        }
        /***/

      },

      /***/
      "./node_modules/redux-saga/es/internal/sagaHelpers/throttle.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/sagaHelpers/throttle.js ***!
        \*********************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersThrottleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return throttle;
        });
        /* harmony import */


        var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./fsmIterator */
        "./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
        /* harmony import */


        var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../io */
        "./node_modules/redux-saga/es/internal/io.js");
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../channel */
        "./node_modules/redux-saga/es/internal/channel.js");
        /* harmony import */


        var _buffers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../buffers */
        "./node_modules/redux-saga/es/internal/buffers.js");
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ../utils */
        "./node_modules/redux-saga/es/internal/utils.js");

        function throttle(delayLength, pattern, worker) {
          for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
            args[_key - 3] = arguments[_key];
          }

          var action = void 0,
              channel = void 0;
          var yActionChannel = {
            done: false,
            value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["actionChannel"])(pattern, _buffers__WEBPACK_IMPORTED_MODULE_3__["buffers"].sliding(1))
          };

          var yTake = function yTake() {
            return {
              done: false,
              value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(channel)
            };
          };

          var yFork = function yFork(ac) {
            return {
              done: false,
              value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac]))
            };
          };

          var yDelay = {
            done: false,
            value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["call"])(_utils__WEBPACK_IMPORTED_MODULE_4__["delay"], delayLength)
          };

          var setAction = function setAction(ac) {
            return action = ac;
          };

          var setChannel = function setChannel(ch) {
            return channel = ch;
          };

          return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
            q1: function q1() {
              return ['q2', yActionChannel, setChannel];
            },
            q2: function q2() {
              return ['q3', yTake(), setAction];
            },
            q3: function q3() {
              return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : ['q4', yFork(action)];
            },
            q4: function q4() {
              return ['q2', yDelay];
            }
          }, 'q1', 'throttle(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(pattern) + ', ' + worker.name + ')');
        }
        /***/

      },

      /***/
      "./node_modules/redux-saga/es/internal/scheduler.js":
      /*!**********************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/scheduler.js ***!
        \**********************************************************/

      /*! exports provided: asap, suspend, flush */

      /***/
      function node_modulesReduxSagaEsInternalSchedulerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "asap", function () {
          return asap;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "suspend", function () {
          return suspend;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "flush", function () {
          return flush;
        });

        var queue = [];
        /**
          Variable to hold a counting semaphore
          - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
            already suspended)
          - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
            triggers flushing the queued tasks.
        **/

        var semaphore = 0;
        /**
          Executes a task 'atomically'. Tasks scheduled during this execution will be queued
          and flushed after this task has finished (assuming the scheduler endup in a released
          state).
        **/

        function exec(task) {
          try {
            suspend();
            task();
          } finally {
            release();
          }
        }
        /**
          Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
        **/


        function asap(task) {
          queue.push(task);

          if (!semaphore) {
            suspend();
            flush();
          }
        }
        /**
          Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
          scheduler is released.
        **/


        function suspend() {
          semaphore++;
        }
        /**
          Puts the scheduler in a `released` state.
        **/


        function release() {
          semaphore--;
        }
        /**
          Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
        **/


        function flush() {
          release();
          var task = void 0;

          while (!semaphore && (task = queue.shift()) !== undefined) {
            exec(task);
          }
        }
        /***/

      },

      /***/
      "./node_modules/redux-saga/es/internal/utils.js":
      /*!******************************************************!*\
        !*** ./node_modules/redux-saga/es/internal/utils.js ***!
        \******************************************************/

      /*! exports provided: sym, TASK, HELPER, MATCH, CANCEL, SAGA_ACTION, SELF_CANCELLATION, konst, kTrue, kFalse, noop, ident, check, hasOwn, is, object, remove, array, deferred, arrayOfDeffered, delay, createMockTask, autoInc, uid, makeIterator, log, deprecate, updateIncentive, internalErr, createSetContextWarning, wrapSagaDispatch, cloneableGenerator */

      /***/
      function node_modulesReduxSagaEsInternalUtilsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "sym", function () {
          return sym;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "TASK", function () {
          return TASK;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "HELPER", function () {
          return HELPER;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "MATCH", function () {
          return MATCH;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "CANCEL", function () {
          return CANCEL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function () {
          return SAGA_ACTION;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "SELF_CANCELLATION", function () {
          return SELF_CANCELLATION;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "konst", function () {
          return konst;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "kTrue", function () {
          return kTrue;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "kFalse", function () {
          return kFalse;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "noop", function () {
          return noop;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ident", function () {
          return ident;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "check", function () {
          return check;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "hasOwn", function () {
          return hasOwn;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "is", function () {
          return is;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "object", function () {
          return object;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "remove", function () {
          return remove;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "array", function () {
          return array;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "deferred", function () {
          return deferred;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "arrayOfDeffered", function () {
          return arrayOfDeffered;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "delay", function () {
          return delay;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createMockTask", function () {
          return createMockTask;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "autoInc", function () {
          return autoInc;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "uid", function () {
          return uid;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeIterator", function () {
          return makeIterator;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "log", function () {
          return log;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "deprecate", function () {
          return deprecate;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "updateIncentive", function () {
          return updateIncentive;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "internalErr", function () {
          return internalErr;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createSetContextWarning", function () {
          return createSetContextWarning;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "wrapSagaDispatch", function () {
          return wrapSagaDispatch;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function () {
          return cloneableGenerator;
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        var sym = function sym(id) {
          return '@@redux-saga/' + id;
        };

        var TASK =
        /*#__PURE__*/
        sym('TASK');
        var HELPER =
        /*#__PURE__*/
        sym('HELPER');
        var MATCH =
        /*#__PURE__*/
        sym('MATCH');
        var CANCEL =
        /*#__PURE__*/
        sym('CANCEL_PROMISE');
        var SAGA_ACTION =
        /*#__PURE__*/
        sym('SAGA_ACTION');
        var SELF_CANCELLATION =
        /*#__PURE__*/
        sym('SELF_CANCELLATION');

        var konst = function konst(v) {
          return function () {
            return v;
          };
        };

        var kTrue =
        /*#__PURE__*/
        konst(true);
        var kFalse =
        /*#__PURE__*/
        konst(false);

        var noop = function noop() {};

        var ident = function ident(v) {
          return v;
        };

        function check(value, predicate, error) {
          if (!predicate(value)) {
            log('error', 'uncaught at check', error);
            throw new Error(error);
          }
        }

        var hasOwnProperty = Object.prototype.hasOwnProperty;

        function hasOwn(object, property) {
          return is.notUndef(object) && hasOwnProperty.call(object, property);
        }

        var is = {
          undef: function undef(v) {
            return v === null || v === undefined;
          },
          notUndef: function notUndef(v) {
            return v !== null && v !== undefined;
          },
          func: function func(f) {
            return typeof f === 'function';
          },
          number: function number(n) {
            return typeof n === 'number';
          },
          string: function string(s) {
            return typeof s === 'string';
          },
          array: Array.isArray,
          object: function object(obj) {
            return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
          },
          promise: function promise(p) {
            return p && is.func(p.then);
          },
          iterator: function iterator(it) {
            return it && is.func(it.next) && is.func(it.throw);
          },
          iterable: function iterable(it) {
            return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
          },
          task: function task(t) {
            return t && t[TASK];
          },
          observable: function observable(ob) {
            return ob && is.func(ob.subscribe);
          },
          buffer: function buffer(buf) {
            return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
          },
          pattern: function pattern(pat) {
            return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
          },
          channel: function channel(ch) {
            return ch && is.func(ch.take) && is.func(ch.close);
          },
          helper: function helper(it) {
            return it && it[HELPER];
          },
          stringableFunc: function stringableFunc(f) {
            return is.func(f) && hasOwn(f, 'toString');
          }
        };
        var object = {
          assign: function assign(target, source) {
            for (var i in source) {
              if (hasOwn(source, i)) {
                target[i] = source[i];
              }
            }
          }
        };

        function remove(array, item) {
          var index = array.indexOf(item);

          if (index >= 0) {
            array.splice(index, 1);
          }
        }

        var array = {
          from: function from(obj) {
            var arr = Array(obj.length);

            for (var i in obj) {
              if (hasOwn(obj, i)) {
                arr[i] = obj[i];
              }
            }

            return arr;
          }
        };

        function deferred() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var def = _extends({}, props);

          var promise = new Promise(function (resolve, reject) {
            def.resolve = resolve;
            def.reject = reject;
          });
          def.promise = promise;
          return def;
        }

        function arrayOfDeffered(length) {
          var arr = [];

          for (var i = 0; i < length; i++) {
            arr.push(deferred());
          }

          return arr;
        }

        function delay(ms) {
          var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          var timeoutId = void 0;
          var promise = new Promise(function (resolve) {
            timeoutId = setTimeout(function () {
              return resolve(val);
            }, ms);
          });

          promise[CANCEL] = function () {
            return clearTimeout(timeoutId);
          };

          return promise;
        }

        function createMockTask() {
          var _ref;

          var running = true;

          var _result = void 0,
              _error = void 0;

          return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
            return running;
          }, _ref.result = function result() {
            return _result;
          }, _ref.error = function error() {
            return _error;
          }, _ref.setRunning = function setRunning(b) {
            return running = b;
          }, _ref.setResult = function setResult(r) {
            return _result = r;
          }, _ref.setError = function setError(e) {
            return _error = e;
          }, _ref;
        }

        function autoInc() {
          var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return function () {
            return ++seed;
          };
        }

        var uid =
        /*#__PURE__*/
        autoInc();

        var kThrow = function kThrow(err) {
          throw err;
        };

        var kReturn = function kReturn(value) {
          return {
            value: value,
            done: true
          };
        };

        function makeIterator(next) {
          var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
          var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          var isHelper = arguments[3];
          var iterator = {
            name: name,
            next: next,
            throw: thro,
            return: kReturn
          };

          if (isHelper) {
            iterator[HELPER] = true;
          }

          if (typeof Symbol !== 'undefined') {
            iterator[Symbol.iterator] = function () {
              return iterator;
            };
          }

          return iterator;
        }
        /**
          Print error in a useful way whether in a browser environment
          (with expandable error stack traces), or in a node.js environment
          (text-only log output)
         **/


        function log(level, message) {
          var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          /*eslint-disable no-console*/

          if (typeof window === 'undefined') {
            console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
          } else {
            console[level](message, error);
          }
        }

        function deprecate(fn, deprecationWarning) {
          return function () {
            if (true) log('warn', deprecationWarning);
            return fn.apply(undefined, arguments);
          };
        }

        var updateIncentive = function updateIncentive(deprecated, preferred) {
          return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
        };

        var internalErr = function internalErr(err) {
          return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
        };

        var createSetContextWarning = function createSetContextWarning(ctx, props) {
          return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
        };

        var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
          return function (action) {
            return dispatch(Object.defineProperty(action, SAGA_ACTION, {
              value: true
            }));
          };
        };

        var cloneableGenerator = function cloneableGenerator(generatorFunc) {
          return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var history = [];
            var gen = generatorFunc.apply(undefined, args);
            return {
              next: function next(arg) {
                history.push(arg);
                return gen.next(arg);
              },
              clone: function clone() {
                var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
                history.forEach(function (arg) {
                  return clonedGen.next(arg);
                });
                return clonedGen;
              },
              return: function _return(value) {
                return gen.return(value);
              },
              throw: function _throw(exception) {
                return gen.throw(exception);
              }
            };
          };
        };
        /***/

      },

      /***/
      "./node_modules/regenerator-runtime/runtime-module.js":
      /*!************************************************************!*\
        !*** ./node_modules/regenerator-runtime/runtime-module.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegeneratorRuntimeRuntimeModuleJs(module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        // This method of obtaining a reference to the global object needs to be
        // kept identical to the way it is obtained in runtime.js
        var g = function () {
          return this;
        }() || Function("return this")(); // Use `getOwnPropertyNames` because not all browsers support calling
        // `hasOwnProperty` on the global `self` object in a worker. See #183.


        var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0; // Save the old regeneratorRuntime in case it needs to be restored later.

        var oldRuntime = hadRuntime && g.regeneratorRuntime; // Force reevalutation of runtime.js.

        g.regeneratorRuntime = undefined;
        module.exports = __webpack_require__(
        /*! ./runtime */
        "./node_modules/regenerator-runtime/runtime.js");

        if (hadRuntime) {
          // Restore the original runtime.
          g.regeneratorRuntime = oldRuntime;
        } else {
          // Remove the global property added by runtime.js.
          try {
            delete g.regeneratorRuntime;
          } catch (e) {
            g.regeneratorRuntime = undefined;
          }
        }
        /***/

      },

      /***/
      "./node_modules/regenerator-runtime/runtime.js":
      /*!*****************************************************!*\
        !*** ./node_modules/regenerator-runtime/runtime.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegeneratorRuntimeRuntimeJs(module, exports) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        !function (global) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined; // More compressible than void 0.

          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
          var inModule = typeof module === "object";
          var runtime = global.regeneratorRuntime;

          if (runtime) {
            if (inModule) {
              // If regeneratorRuntime is defined globally and we're in a module,
              // make the exports object identical to regeneratorRuntime.
              module.exports = runtime;
            } // Don't bother evaluating the rest of this file if the runtime was
            // already defined globally.


            return;
          } // Define the runtime globally (as expected by generated code) as either
          // module.exports (if we're in a module) or a new, empty object.


          runtime = global.regeneratorRuntime = inModule ? module.exports : {};

          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.

            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }

          runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.

          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }

          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.

          var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.


          var IteratorPrototype = {};

          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };

          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }

          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.

          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg);
              };
            });
          }

          runtime.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };

          runtime.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
              }
            }

            genFun.prototype = Object.create(Gp);
            return genFun;
          }; // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.


          runtime.awrap = function (arg) {
            return {
              __await: arg
            };
          };

          function AsyncIterator(generator) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);

              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;

                if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                  return Promise.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }

                return Promise.resolve(value).then(function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration. If the Promise is rejected, however, the
                  // result for this iteration will be rejected with the same
                  // reason. Note that rejections of yielded Promises are not
                  // thrown back into the generator function, as is the case
                  // when an awaited Promise is rejected. This difference in
                  // behavior between yield and await is important, because it
                  // allows the consumer to decide what to do with the yielded
                  // rejection (swallow it and continue, manually .throw it back
                  // into the generator, abandon iteration, whatever). With
                  // await, by contrast, there is no opportunity to examine the
                  // rejection reason outside the generator function, so the
                  // only option is to throw it from the await expression, and
                  // let the generator function handle the exception.
                  result.value = unwrapped;
                  resolve(result);
                }, reject);
              }
            }

            var previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }

              return previousPromise = // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            } // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).


            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };

          runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.

          runtime.async = function (innerFn, outerFn, self, tryLocsList) {
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
            return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };

          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }

              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                } // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                var delegate = context.delegate;

                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === "next") {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }

                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);

                if (record.type === "normal") {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted; // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.

                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          } // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.


          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];

            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;

              if (context.method === "throw") {
                if (delegate.iterator.return) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === "throw") {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }

                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return ContinueSentinel;
            }

            var record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            var info = record.arg;

            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

              context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.

              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            } // The delegate iterator is finished, so forget it and continue with
            // the outer generator.


            context.delegate = null;
            return ContinueSentinel;
          } // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.


          defineIteratorMethods(Gp);
          Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.

          Gp[iteratorSymbol] = function () {
            return this;
          };

          Gp.toString = function () {
            return "[object Generator]";
          };

          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          runtime.keys = function (object) {
            var keys = [];

            for (var key in object) {
              keys.push(key);
            }

            keys.reverse(); // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.

            return function next() {
              while (keys.length) {
                var key = keys.pop();

                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              } // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.


              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];

              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === "function") {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;
                  return next;
                };

                return next.next = next;
              }
            } // Return an iterator with no values.


            return {
              next: doneResult
            };
          }

          runtime.values = values;

          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
              this.prev = 0;
              this.next = 0; // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.

              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (var name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function stop() {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;

              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }

              return this.rval;
            },
            dispatchException: function dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              var context = this;

              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = "next";
                  context.arg = undefined;
                }

                return !!caught;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === "root") {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle("end");
                }

                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function abrupt(type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }

              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }

              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function _catch(tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;

                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }

                  return thrown;
                }
              } // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.


              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };

              if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }

              return ContinueSentinel;
            }
          };
        }( // In sloppy mode, unbound `this` refers to the global object, fallback to
        // Function constructor if we're in global strict mode. That is sadly a form
        // of indirect eval which violates Content Security Policy.
        function () {
          return this;
        }() || Function("return this")());
        /***/
      },

      /***/
      "./src/Drizzle.js":
      /*!************************!*\
        !*** ./src/Drizzle.js ***!
        \************************/

      /*! no static exports found */

      /***/
      function srcDrizzleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _classCallCheck2 = __webpack_require__(
        /*! babel-runtime/helpers/classCallCheck */
        "./node_modules/babel-runtime/helpers/classCallCheck.js");

        var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

        var _createClass2 = __webpack_require__(
        /*! babel-runtime/helpers/createClass */
        "./node_modules/babel-runtime/helpers/createClass.js");

        var _createClass3 = _interopRequireDefault(_createClass2);

        var _promise = __webpack_require__(
        /*! babel-runtime/core-js/promise */
        "./node_modules/babel-runtime/core-js/promise.js");

        var _promise2 = _interopRequireDefault(_promise);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        } // Load as promise so that async Drizzle initialization can still resolve


        var windowPromise = new _promise2.default(function (resolve, reject) {
          window.addEventListener('load', resolve);
        });

        var Drizzle = function () {
          function Drizzle(options, store) {
            var _this = this;

            (0, _classCallCheck3.default)(this, Drizzle); // Variables

            this.contracts = {};
            this.contractList = [];
            this.options = options;
            this.store = store;
            this.web3 = {};
            this.loadingContract = {}; // Wait for window load event in case of injected web3.

            windowPromise.then(function () {
              // Begin Drizzle initialization.
              store.dispatch({
                type: 'DRIZZLE_INITIALIZING',
                drizzle: _this,
                options: options
              });
            });
          }

          (0, _createClass3.default)(Drizzle, [{
            key: 'addContract',
            value: function addContract(contractConfig) {
              var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              this.store.dispatch({
                type: 'ADD_CONTRACT',
                drizzle: this,
                contractConfig: contractConfig,
                events: events,
                web3: this.web3
              });
            }
          }, {
            key: '_addContract',
            value: function _addContract(drizzleContract) {
              if (this.contracts[drizzleContract.contractName]) {
                throw 'Contract already exists: ' + drizzleContract.contractName;
              }

              this.contracts[drizzleContract.contractName] = drizzleContract;
              this.contractList.push(drizzleContract);
            }
          }, {
            key: 'findContractByAddress',
            value: function findContractByAddress(address) {
              return this.contractList.find(function (contract) {
                return contract.address.toLowerCase() === address.toLowerCase();
              });
            }
          }]);
          return Drizzle;
        }();

        exports.default = Drizzle;
        /***/
      },

      /***/
      "./src/DrizzleContract.js":
      /*!********************************!*\
        !*** ./src/DrizzleContract.js ***!
        \********************************/

      /*! no static exports found */

      /***/
      function srcDrizzleContractJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _stringify = __webpack_require__(
        /*! babel-runtime/core-js/json/stringify */
        "./node_modules/babel-runtime/core-js/json/stringify.js");

        var _stringify2 = _interopRequireDefault(_stringify);

        var _typeof2 = __webpack_require__(
        /*! babel-runtime/helpers/typeof */
        "./node_modules/babel-runtime/helpers/typeof.js");

        var _typeof3 = _interopRequireDefault(_typeof2);

        var _assign = __webpack_require__(
        /*! babel-runtime/core-js/object/assign */
        "./node_modules/babel-runtime/core-js/object/assign.js");

        var _assign2 = _interopRequireDefault(_assign);

        var _classCallCheck2 = __webpack_require__(
        /*! babel-runtime/helpers/classCallCheck */
        "./node_modules/babel-runtime/helpers/classCallCheck.js");

        var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

        var _createClass2 = __webpack_require__(
        /*! babel-runtime/helpers/createClass */
        "./node_modules/babel-runtime/helpers/createClass.js");

        var _createClass3 = _interopRequireDefault(_createClass2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var DrizzleContract = function () {
          function DrizzleContract(web3Contract, web3, name, store) {
            var events = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
            var contractArtifact = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            (0, _classCallCheck3.default)(this, DrizzleContract);
            this.abi = web3Contract.options.jsonInterface;
            this.address = web3Contract.options.address;
            this.web3 = web3;
            this.contractName = name;
            this.contractArtifact = contractArtifact;
            this.store = store; // Merge web3 contract instance into DrizzleContract instance.

            (0, _assign2.default)(this, web3Contract);

            for (var i = 0; i < this.abi.length; i++) {
              var item = this.abi[i];

              if (item.type == 'function' && item.constant === true) {
                this.methods[item.name].cacheCall = this.cacheCallFunction(item.name, i);
              }

              if (item.type == 'function' && item.constant === false) {
                this.methods[item.name].cacheSend = this.cacheSendFunction(item.name, i);
              }
            } // Register event listeners if any events.


            if (events.length > 0) {
              for (i = 0; i < events.length; i++) {
                var event = events[i];

                if ((typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) === 'object') {
                  store.dispatch({
                    type: 'LISTEN_FOR_EVENT',
                    contract: this,
                    eventName: event.eventName,
                    eventOptions: event.eventOptions
                  });
                } else {
                  store.dispatch({
                    type: 'LISTEN_FOR_EVENT',
                    contract: this,
                    eventName: event
                  });
                }
              }
            }
          }

          (0, _createClass3.default)(DrizzleContract, [{
            key: 'cacheCallFunction',
            value: function cacheCallFunction(fnName, fnIndex, fn) {
              var contract = this;
              return function () {
                // Collect args and hash to use as key, 0x0 if no args
                var argsHash = '0x0';
                var args = arguments;

                if (args.length > 0) {
                  argsHash = contract.generateArgsHash(args);
                }

                var contractName = contract.contractName;
                var functionState = contract.store.getState().contracts[contractName][fnName]; // If call result is in state and fresh, return value instead of calling

                if (argsHash in functionState) {
                  if (contract.store.getState().contracts[contractName].synced === true) {
                    return argsHash;
                  }
                } // Otherwise, call function and update store


                contract.store.dispatch({
                  type: 'CALL_CONTRACT_FN',
                  contract: contract,
                  fnName: fnName,
                  fnIndex: fnIndex,
                  args: args,
                  argsHash: argsHash
                }); // Return nothing because state is currently empty.

                return argsHash;
              };
            }
          }, {
            key: 'cacheSendFunction',
            value: function cacheSendFunction(fnName, fnIndex, fn) {
              // NOTE: May not need fn index
              var contract = this;
              return function () {
                var args = arguments; // Generate temporary ID

                var stackId = contract.store.getState().transactionStack.length; // Add ID to "transactionStack" with empty value

                contract.store.dispatch({
                  type: 'PUSH_TO_TXSTACK'
                }); // Dispatch tx to saga
                // When txhash received, will be value of stack ID

                contract.store.dispatch({
                  type: 'SEND_CONTRACT_TX',
                  contract: contract,
                  fnName: fnName,
                  fnIndex: fnIndex,
                  args: args,
                  stackId: stackId
                }); // return stack ID

                return stackId;
              };
            }
          }, {
            key: 'generateArgsHash',
            value: function generateArgsHash(args) {
              var web3 = this.web3;
              var hashString = '';

              for (var i = 0; i < args.length; i++) {
                if (typeof args[i] !== 'function') {
                  var argToHash = args[i]; // Stringify objects to allow hashing

                  if ((typeof argToHash === 'undefined' ? 'undefined' : (0, _typeof3.default)(argToHash)) === 'object') {
                    argToHash = (0, _stringify2.default)(argToHash);
                  } // Convert number to strong to allow hashing


                  if (typeof argToHash === 'number') {
                    argToHash = argToHash.toString();
                  } // This check is in place for web3 v0.x


                  if ('utils' in web3) {
                    var hashPiece = web3.utils.sha3(argToHash);
                  } else {
                    var hashPiece = web3.sha3(argToHash);
                  }

                  hashString += hashPiece;
                }
              }

              return web3.utils.sha3(hashString);
            }
          }]);
          return DrizzleContract;
        }();

        exports.default = DrizzleContract;
        /***/
      },

      /***/
      "./src/accountBalances/accountBalancesReducer.js":
      /*!*******************************************************!*\
        !*** ./src/accountBalances/accountBalancesReducer.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function srcAccountBalancesAccountBalancesReducerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _defineProperty2 = __webpack_require__(
        /*! babel-runtime/helpers/defineProperty */
        "./node_modules/babel-runtime/helpers/defineProperty.js");

        var _defineProperty3 = _interopRequireDefault(_defineProperty2);

        var _extends3 = __webpack_require__(
        /*! babel-runtime/helpers/extends */
        "./node_modules/babel-runtime/helpers/extends.js");

        var _extends4 = _interopRequireDefault(_extends3);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var initialState = {};

        var accountBalancesReducer = function accountBalancesReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];

          if (action.type === 'ACCOUNT_BALANCE_FETCHED') {
            return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.account, action.accountBalance));
          }

          return state;
        };

        exports.default = accountBalancesReducer;
        /***/
      },

      /***/
      "./src/accountBalances/accountBalancesSaga.js":
      /*!****************************************************!*\
        !*** ./src/accountBalances/accountBalancesSaga.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function srcAccountBalancesAccountBalancesSagaJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _regenerator = __webpack_require__(
        /*! babel-runtime/regenerator */
        "./node_modules/babel-runtime/regenerator/index.js");

        var _regenerator2 = _interopRequireDefault(_regenerator);

        exports.getAccountBalances = getAccountBalances;

        var _effects = __webpack_require__(
        /*! redux-saga/effects */
        "./node_modules/redux-saga/es/effects.js");

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var _marked =
        /*#__PURE__*/
        _regenerator2.default.mark(getAccountBalances),
            _marked2 =
        /*#__PURE__*/
        _regenerator2.default.mark(accountBalancesSaga);

        function getAccountBalances(action) {
          var accounts, web3, i, account, accountBalance;
          return _regenerator2.default.wrap(function getAccountBalances$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return (0, _effects.select)(getAccountsState);

                case 2:
                  accounts = _context.sent;
                  web3 = action.web3;

                  if (!accounts) {
                    console.error('No accounts found while attempting to fetch balances!');
                  }

                  _context.prev = 5;
                  _context.t0 = _regenerator2.default.keys(accounts);

                case 7:
                  if ((_context.t1 = _context.t0()).done) {
                    _context.next = 17;
                    break;
                  }

                  i = _context.t1.value;
                  account = accounts[i];
                  _context.next = 12;
                  return (0, _effects.call)(web3.eth.getBalance, account);

                case 12:
                  accountBalance = _context.sent;
                  _context.next = 15;
                  return (0, _effects.put)({
                    type: 'ACCOUNT_BALANCE_FETCHED',
                    account: account,
                    accountBalance: accountBalance
                  });

                case 15:
                  _context.next = 7;
                  break;

                case 17:
                  _context.next = 25;
                  break;

                case 19:
                  _context.prev = 19;
                  _context.t2 = _context['catch'](5);
                  _context.next = 23;
                  return (0, _effects.put)({
                    type: 'ACCOUNT_BALANCE_FAILED',
                    error: _context.t2
                  });

                case 23:
                  console.error('Error fetching account ' + account + ' balance:');
                  console.error(_context.t2);

                case 25:
                  _context.next = 27;
                  return (0, _effects.put)({
                    type: 'ACCOUNT_BALANCES_FETCHED'
                  });

                case 27:
                case 'end':
                  return _context.stop();
              }
            }
          }, _marked, this, [[5, 19]]);
        }

        var getAccountsState = function getAccountsState(state) {
          return state.accounts;
        };

        function accountBalancesSaga() {
          return _regenerator2.default.wrap(function accountBalancesSaga$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return (0, _effects.takeLatest)('ACCOUNT_BALANCES_FETCHING', getAccountBalances);

                case 2:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _marked2, this);
        }

        exports.default = accountBalancesSaga;
        /***/
      },

      /***/
      "./src/accounts/accountsReducer.js":
      /*!*****************************************!*\
        !*** ./src/accounts/accountsReducer.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function srcAccountsAccountsReducerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _assign = __webpack_require__(
        /*! babel-runtime/core-js/object/assign */
        "./node_modules/babel-runtime/core-js/object/assign.js");

        var _assign2 = _interopRequireDefault(_assign);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var initialState = {};

        var accountsReducer = function accountsReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];

          if (action.type === 'ACCOUNTS_FETCHING') {
            return state;
          }

          if (action.type === 'ACCOUNTS_FETCHED') {
            return (0, _assign2.default)({}, state, action.accounts);
          }

          return state;
        };

        exports.default = accountsReducer;
        /***/
      },

      /***/
      "./src/accounts/accountsSaga.js":
      /*!**************************************!*\
        !*** ./src/accounts/accountsSaga.js ***!
        \**************************************/

      /*! no static exports found */

      /***/
      function srcAccountsAccountsSagaJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _regenerator = __webpack_require__(
        /*! babel-runtime/regenerator */
        "./node_modules/babel-runtime/regenerator/index.js");

        var _regenerator2 = _interopRequireDefault(_regenerator);

        exports.getAccounts = getAccounts;

        var _reduxSaga = __webpack_require__(
        /*! redux-saga */
        "redux-saga");

        var _effects = __webpack_require__(
        /*! redux-saga/effects */
        "./node_modules/redux-saga/es/effects.js");

        var _accountBalancesSaga = __webpack_require__(
        /*! ../accountBalances/accountBalancesSaga */
        "./src/accountBalances/accountBalancesSaga.js");

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var _marked =
        /*#__PURE__*/
        _regenerator2.default.mark(getAccounts),
            _marked2 =
        /*#__PURE__*/
        _regenerator2.default.mark(createAccountsPollChannel),
            _marked3 =
        /*#__PURE__*/
        _regenerator2.default.mark(callCreateAccountsPollChannel),
            _marked4 =
        /*#__PURE__*/
        _regenerator2.default.mark(accountsSaga);
        /*
         * Fetch Accounts List
         */


        function getAccounts(action) {
          var web3, accounts;
          return _regenerator2.default.wrap(function getAccounts$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  web3 = action.web3;
                  _context.prev = 1;
                  _context.next = 4;
                  return (0, _effects.call)(web3.eth.getAccounts);

                case 4:
                  accounts = _context.sent;

                  if (accounts) {
                    _context.next = 7;
                    break;
                  }

                  throw 'No accounts found!';

                case 7:
                  _context.next = 9;
                  return (0, _effects.put)({
                    type: 'ACCOUNTS_FETCHED',
                    accounts: accounts
                  });

                case 9:
                  _context.next = 17;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context['catch'](1);
                  _context.next = 15;
                  return (0, _effects.put)({
                    type: 'ACCOUNTS_FAILED',
                    error: _context.t0
                  });

                case 15:
                  console.error('Error fetching accounts:');
                  console.error(_context.t0);

                case 17:
                case 'end':
                  return _context.stop();
              }
            }
          }, _marked, this, [[1, 11]]);
        }
        /*
         * Poll for Account Changes
         */


        function createAccountsPollChannel(_ref) {
          var interval = _ref.interval,
              web3 = _ref.web3;
          return _regenerator2.default.wrap(function createAccountsPollChannel$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt('return', (0, _reduxSaga.eventChannel)(function (emit) {
                    var persistedWeb3 = web3;
                    var accountsPoller = setInterval(function () {
                      emit({
                        type: 'SYNCING_ACCOUNTS',
                        persistedWeb3: persistedWeb3
                      });
                    }, interval); // options.polls.accounts

                    var unsubscribe = function unsubscribe() {
                      clearInterval(accountsPoller);
                    };

                    return unsubscribe;
                  }));

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _marked2, this);
        }

        function callCreateAccountsPollChannel(_ref2) {
          var interval = _ref2.interval,
              web3 = _ref2.web3;
          var accountsChannel, event;
          return _regenerator2.default.wrap(function callCreateAccountsPollChannel$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0, _effects.call)(createAccountsPollChannel, {
                    interval: interval,
                    web3: web3
                  });

                case 2:
                  accountsChannel = _context3.sent;
                  _context3.prev = 3;

                case 4:
                  if (false) {}

                  _context3.next = 7;
                  return (0, _effects.take)(accountsChannel);

                case 7:
                  event = _context3.sent;

                  if (!(event.type === 'SYNCING_ACCOUNTS')) {
                    _context3.next = 13;
                    break;
                  }

                  _context3.next = 11;
                  return (0, _effects.call)(getAccounts, {
                    web3: event.persistedWeb3
                  });

                case 11:
                  _context3.next = 13;
                  return (0, _effects.call)(_accountBalancesSaga.getAccountBalances, {
                    web3: event.persistedWeb3
                  });

                case 13:
                  _context3.next = 15;
                  return (0, _effects.put)(event);

                case 15:
                  _context3.next = 4;
                  break;

                case 17:
                  _context3.prev = 17;
                  accountsChannel.close();
                  return _context3.finish(17);

                case 20:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _marked3, this, [[3,, 17, 20]]);
        }

        function accountsSaga() {
          return _regenerator2.default.wrap(function accountsSaga$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return (0, _effects.takeLatest)('ACCOUNTS_FETCHING', getAccounts);

                case 2:
                  _context4.next = 4;
                  return (0, _effects.takeLatest)('ACCOUNTS_POLLING', callCreateAccountsPollChannel);

                case 4:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _marked4, this);
        }

        exports.default = accountsSaga;
        /***/
      },

      /***/
      "./src/blocks/blocksSaga.js":
      /*!**********************************!*\
        !*** ./src/blocks/blocksSaga.js ***!
        \**********************************/

      /*! no static exports found */

      /***/
      function srcBlocksBlocksSagaJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _keys = __webpack_require__(
        /*! babel-runtime/core-js/object/keys */
        "./node_modules/babel-runtime/core-js/object/keys.js");

        var _keys2 = _interopRequireDefault(_keys);

        var _regenerator = __webpack_require__(
        /*! babel-runtime/regenerator */
        "./node_modules/babel-runtime/regenerator/index.js");

        var _regenerator2 = _interopRequireDefault(_regenerator);

        var _reduxSaga = __webpack_require__(
        /*! redux-saga */
        "redux-saga");

        var _effects = __webpack_require__(
        /*! redux-saga/effects */
        "./node_modules/redux-saga/es/effects.js");

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var _marked =
        /*#__PURE__*/
        _regenerator2.default.mark(callCreateBlockChannel),
            _marked2 =
        /*#__PURE__*/
        _regenerator2.default.mark(callCreateBlockPollChannel),
            _marked3 =
        /*#__PURE__*/
        _regenerator2.default.mark(processBlockHeader),
            _marked4 =
        /*#__PURE__*/
        _regenerator2.default.mark(processBlock),
            _marked5 =
        /*#__PURE__*/
        _regenerator2.default.mark(blocksSaga);

        var BlockTracker = __webpack_require__(
        /*! eth-block-tracker */
        "eth-block-tracker");
        /*
         * Listen for Blocks
         */


        function createBlockChannel(_ref) {
          var drizzle = _ref.drizzle,
              web3 = _ref.web3,
              syncAlways = _ref.syncAlways;
          return (0, _reduxSaga.eventChannel)(function (emit) {
            var blockEvents = web3.eth.subscribe('newBlockHeaders', function (error, result) {
              if (error) {
                emit({
                  type: 'BLOCKS_FAILED',
                  error: error
                });
                console.error('Error in block header subscription:');
                console.error(error);
                emit(_reduxSaga.END);
              }
            }).on('data', function (blockHeader) {
              emit({
                type: 'BLOCK_RECEIVED',
                blockHeader: blockHeader,
                drizzle: drizzle,
                web3: web3,
                syncAlways: syncAlways
              });
            }).on('error', function (error) {
              emit({
                type: 'BLOCKS_FAILED',
                error: error
              });
              emit(_reduxSaga.END);
            });

            var unsubscribe = function unsubscribe() {
              blockEvents.off();
            };

            return unsubscribe;
          });
        }

        function callCreateBlockChannel(_ref2) {
          var drizzle = _ref2.drizzle,
              web3 = _ref2.web3,
              syncAlways = _ref2.syncAlways;
          var blockChannel, event;
          return _regenerator2.default.wrap(function callCreateBlockChannel$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return (0, _effects.call)(createBlockChannel, {
                    drizzle: drizzle,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 2:
                  blockChannel = _context.sent;
                  _context.prev = 3;

                case 4:
                  if (false) {}

                  _context.next = 7;
                  return (0, _effects.take)(blockChannel);

                case 7:
                  event = _context.sent;
                  _context.next = 10;
                  return (0, _effects.put)(event);

                case 10:
                  _context.next = 4;
                  break;

                case 12:
                  _context.prev = 12;
                  blockChannel.close();
                  return _context.finish(12);

                case 15:
                case 'end':
                  return _context.stop();
              }
            }
          }, _marked, this, [[3,, 12, 15]]);
        }
        /*
         * Poll for Blocks
         */


        function createBlockPollChannel(_ref3) {
          var drizzle = _ref3.drizzle,
              interval = _ref3.interval,
              web3 = _ref3.web3,
              syncAlways = _ref3.syncAlways;
          return (0, _reduxSaga.eventChannel)(function (emit) {
            var blockTracker = new BlockTracker({
              provider: web3.currentProvider,
              pollingInterval: interval
            });
            blockTracker.on('latest', function (block) {
              emit({
                type: 'BLOCK_FOUND',
                block: block,
                drizzle: drizzle,
                web3: web3,
                syncAlways: syncAlways
              });
            });
            blockTracker.start().catch(function (error) {
              emit({
                type: 'BLOCKS_FAILED',
                error: error
              });
              emit(_reduxSaga.END);
            });

            var unsubscribe = function unsubscribe() {
              blockTracker.stop();
            };

            return unsubscribe;
          });
        }

        function callCreateBlockPollChannel(_ref4) {
          var drizzle = _ref4.drizzle,
              interval = _ref4.interval,
              web3 = _ref4.web3,
              syncAlways = _ref4.syncAlways;
          var blockChannel, event;
          return _regenerator2.default.wrap(function callCreateBlockPollChannel$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return (0, _effects.call)(createBlockPollChannel, {
                    drizzle: drizzle,
                    interval: interval,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 2:
                  blockChannel = _context2.sent;
                  _context2.prev = 3;

                case 4:
                  if (false) {}

                  _context2.next = 7;
                  return (0, _effects.take)(blockChannel);

                case 7:
                  event = _context2.sent;
                  _context2.next = 10;
                  return (0, _effects.put)(event);

                case 10:
                  _context2.next = 4;
                  break;

                case 12:
                  _context2.prev = 12;
                  blockChannel.close();
                  return _context2.finish(12);

                case 15:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _marked2, this, [[3,, 12, 15]]);
        }
        /*
         * Process Blocks
         */


        function processBlockHeader(_ref5) {
          var blockHeader = _ref5.blockHeader,
              drizzle = _ref5.drizzle,
              web3 = _ref5.web3,
              syncAlways = _ref5.syncAlways;
          var blockNumber, block;
          return _regenerator2.default.wrap(function processBlockHeader$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  blockNumber = blockHeader.number;
                  _context3.prev = 1;
                  _context3.next = 4;
                  return (0, _effects.call)(web3.eth.getBlock, blockNumber, true);

                case 4:
                  block = _context3.sent;
                  _context3.next = 7;
                  return (0, _effects.call)(processBlock, {
                    block: block,
                    drizzle: drizzle,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 7:
                  _context3.next = 15;
                  break;

                case 9:
                  _context3.prev = 9;
                  _context3.t0 = _context3['catch'](1);
                  console.error('Error in block processing:');
                  console.error(_context3.t0);
                  _context3.next = 15;
                  return (0, _effects.put)({
                    type: 'BLOCK_FAILED',
                    error: _context3.t0
                  });

                case 15:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _marked3, this, [[1, 9]]);
        }

        function processBlock(_ref6) {
          var block = _ref6.block,
              drizzle = _ref6.drizzle,
              web3 = _ref6.web3,
              syncAlways = _ref6.syncAlways;
          var txs, i, from, fromContract, to, toContract;
          return _regenerator2.default.wrap(function processBlock$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;

                  if (!syncAlways) {
                    _context4.next = 5;
                    break;
                  }

                  _context4.next = 4;
                  return (0, _effects.all)((0, _keys2.default)(drizzle.contracts).map(function (key) {
                    return (0, _effects.put)({
                      type: 'CONTRACT_SYNCING',
                      contract: drizzle.contracts[key]
                    });
                  }));

                case 4:
                  return _context4.abrupt('return');

                case 5:
                  txs = block.transactions;

                  if (!(txs.length > 0)) {
                    _context4.next = 22;
                    break;
                  }

                  i = 0;

                case 8:
                  if (!(i < txs.length)) {
                    _context4.next = 22;
                    break;
                  }

                  from = txs[i].from || '';
                  fromContract = drizzle.findContractByAddress(from.toLowerCase());

                  if (!fromContract) {
                    _context4.next = 14;
                    break;
                  }

                  _context4.next = 14;
                  return (0, _effects.put)({
                    type: 'CONTRACT_SYNCING',
                    contract: fromContract
                  });

                case 14:
                  to = txs[i].to || '';
                  toContract = drizzle.findContractByAddress(to.toLowerCase());

                  if (!toContract) {
                    _context4.next = 19;
                    break;
                  }

                  _context4.next = 19;
                  return (0, _effects.put)({
                    type: 'CONTRACT_SYNCING',
                    contract: toContract
                  });

                case 19:
                  i++;
                  _context4.next = 8;
                  break;

                case 22:
                  _context4.next = 30;
                  break;

                case 24:
                  _context4.prev = 24;
                  _context4.t0 = _context4['catch'](0);
                  console.error('Error in block processing:');
                  console.error(_context4.t0);
                  _context4.next = 30;
                  return (0, _effects.put)({
                    type: 'BLOCK_FAILED',
                    error: _context4.t0
                  });

                case 30:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _marked4, this, [[0, 24]]);
        }

        function blocksSaga() {
          return _regenerator2.default.wrap(function blocksSaga$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return (0, _effects.takeLatest)('BLOCKS_LISTENING', callCreateBlockChannel);

                case 2:
                  _context5.next = 4;
                  return (0, _effects.takeEvery)('BLOCK_RECEIVED', processBlockHeader);

                case 4:
                  _context5.next = 6;
                  return (0, _effects.takeLatest)('BLOCKS_POLLING', callCreateBlockPollChannel);

                case 6:
                  _context5.next = 8;
                  return (0, _effects.takeEvery)('BLOCK_FOUND', processBlock);

                case 8:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _marked5, this);
        }

        exports.default = blocksSaga;
        /***/
      },

      /***/
      "./src/contracts/contractsReducer.js":
      /*!*******************************************!*\
        !*** ./src/contracts/contractsReducer.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function srcContractsContractsReducerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _toConsumableArray2 = __webpack_require__(
        /*! babel-runtime/helpers/toConsumableArray */
        "./node_modules/babel-runtime/helpers/toConsumableArray.js");

        var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

        var _defineProperty2 = __webpack_require__(
        /*! babel-runtime/helpers/defineProperty */
        "./node_modules/babel-runtime/helpers/defineProperty.js");

        var _defineProperty3 = _interopRequireDefault(_defineProperty2);

        var _extends14 = __webpack_require__(
        /*! babel-runtime/helpers/extends */
        "./node_modules/babel-runtime/helpers/extends.js");

        var _extends15 = _interopRequireDefault(_extends14);

        var _generateContractInitialState = __webpack_require__(
        /*! ../generateContractInitialState */
        "./src/generateContractInitialState.js");

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var initialState = {};

        var contractsReducer = function contractsReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];
          /*
           * Contract Status
           */

          if (action.type === 'CONTRACT_INITIALIZING') {
            return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.contractConfig.contractName, (0, _generateContractInitialState.generateContractInitialState)(action.contractConfig)));
          }

          if (action.type === 'CONTRACT_INITIALIZED') {
            return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.name, (0, _extends15.default)({}, state[action.name], {
              initialized: true,
              synced: true,
              events: []
            })));
          }

          if (action.type === 'CONTRACT_SYNCING') {
            var contractName = action.contract.contractName;
            return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, contractName, (0, _extends15.default)({}, state[contractName], {
              synced: false
            })));
          }

          if (action.type === 'CONTRACT_SYNCED') {
            return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.contractName, (0, _extends15.default)({}, state[action.contractName], {
              synced: true
            })));
          }

          if (action.type === 'CONTRACT_SYNC_IND') {
            return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.contractName, (0, _extends15.default)({}, state[action.contractName], {
              synced: false
            })));
          }
          /*
           * Contract Functions
           */


          if (action.type === 'GOT_CONTRACT_VAR') {
            return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.name, (0, _extends15.default)({}, state[action.name], (0, _defineProperty3.default)({}, action.variable, (0, _extends15.default)({}, state[action.name][action.variable], (0, _defineProperty3.default)({}, action.argsHash, (0, _extends15.default)({}, state[action.name][action.variable][action.argsHash], {
              args: action.args,
              fnIndex: action.fnIndex,
              value: action.value
            })))))));
          }

          if (action.type === 'ERROR_CONTRACT_VAR') {
            return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.name, (0, _extends15.default)({}, state[action.name], (0, _defineProperty3.default)({}, action.variable, (0, _extends15.default)({}, state[action.name][action.variable], (0, _defineProperty3.default)({}, action.argsHash, (0, _extends15.default)({}, state[action.name][action.variable][action.argsHash], {
              args: action.args,
              fnIndex: action.fnIndex,
              error: action.error
            })))))));
          }
          /*
           * Contract Events
           */


          if (action.type === 'EVENT_FIRED') {
            return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.name, (0, _extends15.default)({}, state[action.name], {
              events: [].concat((0, _toConsumableArray3.default)(state[action.name].events), [action.event])
            })));
          }

          return state;
        };

        exports.default = contractsReducer;
        /***/
      },

      /***/
      "./src/contracts/contractsSaga.js":
      /*!****************************************!*\
        !*** ./src/contracts/contractsSaga.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function srcContractsContractsSagaJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _assign = __webpack_require__(
        /*! babel-runtime/core-js/object/assign */
        "./node_modules/babel-runtime/core-js/object/assign.js");

        var _assign2 = _interopRequireDefault(_assign);

        var _extends2 = __webpack_require__(
        /*! babel-runtime/helpers/extends */
        "./node_modules/babel-runtime/helpers/extends.js");

        var _extends3 = _interopRequireDefault(_extends2);

        var _toConsumableArray2 = __webpack_require__(
        /*! babel-runtime/helpers/toConsumableArray */
        "./node_modules/babel-runtime/helpers/toConsumableArray.js");

        var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

        var _typeof2 = __webpack_require__(
        /*! babel-runtime/helpers/typeof */
        "./node_modules/babel-runtime/helpers/typeof.js");

        var _typeof3 = _interopRequireDefault(_typeof2);

        var _regenerator = __webpack_require__(
        /*! babel-runtime/regenerator */
        "./node_modules/babel-runtime/regenerator/index.js");

        var _regenerator2 = _interopRequireDefault(_regenerator);

        exports.addContract = addContract;
        exports.instantiateWeb3Contract = instantiateWeb3Contract;
        exports.instantiateContract = instantiateContract;

        var _reduxSaga = __webpack_require__(
        /*! redux-saga */
        "redux-saga");

        var _effects = __webpack_require__(
        /*! redux-saga/effects */
        "./node_modules/redux-saga/es/effects.js");

        var _DrizzleContract = __webpack_require__(
        /*! ../DrizzleContract */
        "./src/DrizzleContract.js");

        var _DrizzleContract2 = _interopRequireDefault(_DrizzleContract);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var _marked =
        /*#__PURE__*/
        _regenerator2.default.mark(addContract),
            _marked2 =
        /*#__PURE__*/
        _regenerator2.default.mark(instantiateWeb3Contract),
            _marked3 =
        /*#__PURE__*/
        _regenerator2.default.mark(instantiateContract),
            _marked4 =
        /*#__PURE__*/
        _regenerator2.default.mark(callListenForContractEvent),
            _marked5 =
        /*#__PURE__*/
        _regenerator2.default.mark(callSendContractTx),
            _marked6 =
        /*#__PURE__*/
        _regenerator2.default.mark(callCallContractFn),
            _marked7 =
        /*#__PURE__*/
        _regenerator2.default.mark(callSyncContract),
            _marked8 =
        /*#__PURE__*/
        _regenerator2.default.mark(contractsSaga);

        function addContract(_ref) {
          var drizzle = _ref.drizzle,
              contractConfig = _ref.contractConfig,
              events = _ref.events,
              web3 = _ref.web3;
          var drizzleContract;
          return _regenerator2.default.wrap(function addContract$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!drizzle.loadingContract[contractConfig.contractName]) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt('return', false);

                case 2:
                  drizzle.loadingContract[contractConfig.contractName] = true;
                  _context.next = 5;
                  return (0, _effects.put)({
                    type: 'CONTRACT_INITIALIZING',
                    contractConfig: contractConfig
                  });

                case 5:
                  drizzleContract = void 0;

                  if (!contractConfig.web3Contract) {
                    _context.next = 12;
                    break;
                  }

                  _context.next = 9;
                  return (0, _effects.call)(instantiateWeb3Contract, {
                    web3Contract: contractConfig.web3Contract,
                    name: contractConfig.contractName,
                    events: events,
                    store: drizzle.store,
                    web3: web3
                  });

                case 9:
                  drizzleContract = _context.sent;
                  _context.next = 15;
                  break;

                case 12:
                  _context.next = 14;
                  return (0, _effects.call)(instantiateContract, {
                    contractArtifact: contractConfig,
                    events: events,
                    store: drizzle.store,
                    web3: web3
                  });

                case 14:
                  drizzleContract = _context.sent;

                case 15:
                  drizzle._addContract(drizzleContract);

                  _context.next = 18;
                  return (0, _effects.put)({
                    type: 'CONTRACT_INITIALIZED',
                    name: contractConfig.contractName
                  });

                case 18:
                case 'end':
                  return _context.stop();
              }
            }
          }, _marked, this);
        }
        /*
         * Instantiation
         */


        function instantiateWeb3Contract(_ref2) {
          var web3Contract = _ref2.web3Contract,
              name = _ref2.name,
              events = _ref2.events,
              store = _ref2.store,
              web3 = _ref2.web3;
          return _regenerator2.default.wrap(function instantiateWeb3Contract$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt('return', new _DrizzleContract2.default(web3Contract, web3, name, store, events));

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _marked2, this);
        }

        function instantiateContract(_ref3) {
          var contractArtifact = _ref3.contractArtifact,
              events = _ref3.events,
              store = _ref3.store,
              web3 = _ref3.web3;
          var networkId, web3Contract;
          return _regenerator2.default.wrap(function instantiateContract$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0, _effects.select)(getNetworkId);

                case 2:
                  networkId = _context3.sent; // Instantiate the contract.

                  web3Contract = new web3.eth.Contract(contractArtifact.abi, contractArtifact.networks[networkId].address, {
                    from: store.getState().accounts[0],
                    data: contractArtifact.deployedBytecode
                  });
                  return _context3.abrupt('return', new _DrizzleContract2.default(web3Contract, web3, contractArtifact.contractName, store, events, contractArtifact));

                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _marked3, this);
        }
        /*
         * Events
         */


        function createContractEventChannel(_ref4) {
          var contract = _ref4.contract,
              eventName = _ref4.eventName,
              eventOptions = _ref4.eventOptions;
          var name = contract.contractName;
          return (0, _reduxSaga.eventChannel)(function (emit) {
            var eventListener = contract.events[eventName](eventOptions).on('data', function (event) {
              emit({
                type: 'EVENT_FIRED',
                name: name,
                event: event
              });
            }).on('changed', function (event) {
              emit({
                type: 'EVENT_CHANGED',
                name: name,
                event: event
              });
            }).on('error', function (error) {
              emit({
                type: 'EVENT_ERROR',
                name: name,
                error: error
              });
              emit(_reduxSaga.END);
            });

            var unsubscribe = function unsubscribe() {
              eventListener.removeListener(eventName);
            };

            return unsubscribe;
          });
        }

        function callListenForContractEvent(_ref5) {
          var contract = _ref5.contract,
              eventName = _ref5.eventName,
              eventOptions = _ref5.eventOptions;
          var contractEventChannel, event;
          return _regenerator2.default.wrap(function callListenForContractEvent$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return (0, _effects.call)(createContractEventChannel, {
                    contract: contract,
                    eventName: eventName,
                    eventOptions: eventOptions
                  });

                case 2:
                  contractEventChannel = _context4.sent;

                case 3:
                  if (false) {}

                  _context4.next = 6;
                  return (0, _effects.take)(contractEventChannel);

                case 6:
                  event = _context4.sent;
                  _context4.next = 9;
                  return (0, _effects.put)(event);

                case 9:
                  _context4.next = 3;
                  break;

                case 11:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _marked4, this);
        }
        /*
         * Send and Cache
         */


        function createTxChannel(_ref6) {
          var txObject = _ref6.txObject,
              stackId = _ref6.stackId,
              _ref6$sendArgs = _ref6.sendArgs,
              sendArgs = _ref6$sendArgs === undefined ? {} : _ref6$sendArgs,
              contractName = _ref6.contractName;
          var persistTxHash;
          return (0, _reduxSaga.eventChannel)(function (emit) {
            var txPromiEvent = txObject.send(sendArgs).on('transactionHash', function (txHash) {
              persistTxHash = txHash;
              emit({
                type: 'TX_BROADCASTED',
                txHash: txHash,
                stackId: stackId
              });
              emit({
                type: 'CONTRACT_SYNC_IND',
                contractName: contractName
              });
            }).on('confirmation', function (confirmationNumber, receipt) {
              emit({
                type: 'TX_CONFIRMAITON',
                confirmationReceipt: receipt,
                txHash: persistTxHash
              });
            }).on('receipt', function (receipt) {
              emit({
                type: 'TX_SUCCESSFUL',
                receipt: receipt,
                txHash: persistTxHash
              });
              emit(_reduxSaga.END);
            }).on('error', function (error) {
              emit({
                type: 'TX_ERROR',
                error: error,
                txHash: persistTxHash
              });
              emit(_reduxSaga.END);
            });

            var unsubscribe = function unsubscribe() {
              txPromiEvent.off();
            };

            return unsubscribe;
          });
        }

        function callSendContractTx(_ref7) {
          var contract = _ref7.contract,
              fnName = _ref7.fnName,
              fnIndex = _ref7.fnIndex,
              args = _ref7.args,
              stackId = _ref7.stackId;
          var finalArg, sendArgs, finalArgTest, contractName, txObject, txChannel, event;
          return _regenerator2.default.wrap(function callSendContractTx$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  // Check for type of object and properties indicative of call/send options.
                  if (args.length) {
                    finalArg = args.length > 1 ? args[args.length - 1] : args[0];
                    sendArgs = {};
                    finalArgTest = false;

                    if ((typeof finalArg === 'undefined' ? 'undefined' : (0, _typeof3.default)(finalArg)) === 'object') {
                      finalArgTest = (0, _effects.call)(isSendOrCallOptions, finalArg);
                    }

                    if (finalArgTest) {
                      sendArgs = finalArg;
                      args.length > 1 ? delete args[args.length - 1] : delete args[0];
                      args.length = args.length - 1;
                    }
                  } // Get name to mark as desynchronized on tx creation


                  contractName = contract.contractName; // Create the transaction object and execute the tx.

                  _context5.next = 4;
                  return _effects.call.apply(undefined, [contract.methods[fnName]].concat((0, _toConsumableArray3.default)(args)));

                case 4:
                  txObject = _context5.sent;
                  _context5.next = 7;
                  return (0, _effects.call)(createTxChannel, {
                    txObject: txObject,
                    stackId: stackId,
                    sendArgs: sendArgs,
                    contractName: contractName
                  });

                case 7:
                  txChannel = _context5.sent;
                  _context5.prev = 8;

                case 9:
                  if (false) {}

                  _context5.next = 12;
                  return (0, _effects.take)(txChannel);

                case 12:
                  event = _context5.sent;
                  _context5.next = 15;
                  return (0, _effects.put)(event);

                case 15:
                  _context5.next = 9;
                  break;

                case 17:
                  _context5.prev = 17;
                  txChannel.close();
                  return _context5.finish(17);

                case 20:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _marked5, this, [[8,, 17, 20]]);
        }
        /*
         * Call and Cache
         */


        function callCallContractFn(_ref8) {
          var contract = _ref8.contract,
              fnName = _ref8.fnName,
              fnIndex = _ref8.fnIndex,
              args = _ref8.args,
              argsHash = _ref8.argsHash,
              _ref8$sync = _ref8.sync,
              sync = _ref8$sync === undefined ? false : _ref8$sync;
          var finalArg, callArgs, finalArgTest, txObject, callResult, dispatchArgs, errorArgs;
          return _regenerator2.default.wrap(function callCallContractFn$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!sync) {
                    _context6.next = 2;
                    break;
                  }

                  return _context6.abrupt('return');

                case 2:
                  // Check for type of object and properties indicative of call/send options.
                  if (args.length) {
                    finalArg = args.length > 1 ? args[args.length - 1] : args[0];
                    callArgs = {};
                    finalArgTest = false;

                    if ((typeof finalArg === 'undefined' ? 'undefined' : (0, _typeof3.default)(finalArg)) === 'object') {
                      finalArgTest = (0, _effects.call)(isSendOrCallOptions, finalArg);
                    }

                    if (finalArgTest) {
                      callArgs = finalArg;
                      args.length > 1 ? delete args[args.length - 1] : delete args[0];
                      args.length = args.length - 1;
                    }
                  } // Create the transaction object and execute the call.


                  _context6.next = 5;
                  return _effects.call.apply(undefined, [contract.methods[fnName]].concat((0, _toConsumableArray3.default)(args)));

                case 5:
                  txObject = _context6.sent;
                  _context6.prev = 6;
                  _context6.next = 9;
                  return (0, _effects.call)(txObject.call, callArgs);

                case 9:
                  callResult = _context6.sent;
                  dispatchArgs = {
                    name: contract.contractName,
                    variable: contract.abi[fnIndex].name,
                    argsHash: argsHash,
                    args: args,
                    value: callResult,
                    fnIndex: fnIndex
                  };
                  _context6.next = 13;
                  return (0, _effects.put)((0, _extends3.default)({
                    type: 'GOT_CONTRACT_VAR'
                  }, dispatchArgs));

                case 13:
                  _context6.next = 21;
                  break;

                case 15:
                  _context6.prev = 15;
                  _context6.t0 = _context6['catch'](6);
                  console.error(_context6.t0);
                  errorArgs = {
                    name: contract.contractName,
                    variable: contract.abi[fnIndex].name,
                    argsHash: argsHash,
                    args: args,
                    error: _context6.t0,
                    fnIndex: fnIndex
                  };
                  _context6.next = 21;
                  return (0, _effects.put)((0, _extends3.default)({
                    type: 'ERROR_CONTRACT_VAR'
                  }, errorArgs));

                case 21:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _marked6, this, [[6, 15]]);
        }
        /*
         * Sync Contract
         */


        function callSyncContract(action) {
          var contract, contractName, contractsState, contractFnsState, fnName, argsHash, fnIndex, args;
          return _regenerator2.default.wrap(function callSyncContract$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  // Get contract state from store
                  contract = action.contract;
                  contractName = contract.contractName;
                  _context7.next = 4;
                  return (0, _effects.select)(getContractsState);

                case 4:
                  contractsState = _context7.sent;
                  contractFnsState = (0, _assign2.default)({}, contractsState[contractName]); // Remove unnecessary keys

                  delete contractFnsState.initialized;
                  delete contractFnsState.synced;
                  delete contractFnsState.events; // Iterate over functions and hashes

                  _context7.t0 = _regenerator2.default.keys(contractFnsState);

                case 10:
                  if ((_context7.t1 = _context7.t0()).done) {
                    _context7.next = 25;
                    break;
                  }

                  fnName = _context7.t1.value;
                  _context7.t2 = _regenerator2.default.keys(contractFnsState[fnName]);

                case 13:
                  if ((_context7.t3 = _context7.t2()).done) {
                    _context7.next = 23;
                    break;
                  }

                  argsHash = _context7.t3.value;
                  fnIndex = contractFnsState[fnName][argsHash].fnIndex;
                  args = contractFnsState[fnName][argsHash].args; // Pull args and call fn for each given function
                  // keeping for pre-v1.1.5 compatibility with CALL_CONTRACT_FN event.

                  _context7.next = 19;
                  return (0, _effects.put)({
                    type: 'CALL_CONTRACT_FN',
                    contract: contract,
                    fnName: fnName,
                    fnIndex: fnIndex,
                    args: args,
                    argsHash: argsHash,
                    sync: true
                  });

                case 19:
                  _context7.next = 21;
                  return (0, _effects.call)(callCallContractFn, {
                    contract: contract,
                    fnName: fnName,
                    fnIndex: fnIndex,
                    args: args,
                    argsHash: argsHash
                  });

                case 21:
                  _context7.next = 13;
                  break;

                case 23:
                  _context7.next = 10;
                  break;

                case 25:
                  _context7.next = 27;
                  return (0, _effects.put)({
                    type: 'CONTRACT_SYNCED',
                    contractName: contractName
                  });

                case 27:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _marked7, this);
        }

        var getContractsState = function getContractsState(state) {
          return state.contracts;
        };

        var getNetworkId = function getNetworkId(state) {
          return state.web3.networkId;
        };

        function isSendOrCallOptions(options) {
          if ('from' in options) return true;
          if ('gas' in options) return true;
          if ('gasPrice' in options) return true;
          if ('value' in options) return true;
          return false;
        }

        function contractsSaga() {
          return _regenerator2.default.wrap(function contractsSaga$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return (0, _effects.takeEvery)('SEND_CONTRACT_TX', callSendContractTx);

                case 2:
                  _context8.next = 4;
                  return (0, _effects.takeEvery)('CALL_CONTRACT_FN', callCallContractFn);

                case 4:
                  _context8.next = 6;
                  return (0, _effects.takeEvery)('CONTRACT_SYNCING', callSyncContract);

                case 6:
                  _context8.next = 8;
                  return (0, _effects.takeEvery)('LISTEN_FOR_EVENT', callListenForContractEvent);

                case 8:
                  _context8.next = 10;
                  return (0, _effects.takeEvery)('ADD_CONTRACT', addContract);

                case 10:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _marked8, this);
        }

        exports.default = contractsSaga;
        /***/
      },

      /***/
      "./src/defaultOptions.js":
      /*!*******************************!*\
        !*** ./src/defaultOptions.js ***!
        \*******************************/

      /*! no static exports found */

      /***/
      function srcDefaultOptionsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var defaultOptions = {
          web3: {
            // `block` no longer needed;
            // keeping for pre-v1.1.1 compatibility with drizzle-react.
            block: false,
            fallback: {
              type: 'ws',
              url: 'ws://127.0.0.1:8545'
            }
          },
          contracts: [],
          events: {},
          polls: {
            blocks: 3000
          },
          syncAlways: false
        };
        exports.default = defaultOptions;
        /***/
      },

      /***/
      "./src/drizzleStatus/drizzleStatusReducer.js":
      /*!***************************************************!*\
        !*** ./src/drizzleStatus/drizzleStatusReducer.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function srcDrizzleStatusDrizzleStatusReducerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends2 = __webpack_require__(
        /*! babel-runtime/helpers/extends */
        "./node_modules/babel-runtime/helpers/extends.js");

        var _extends3 = _interopRequireDefault(_extends2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var initialState = {
          initialized: false
        };

        var drizzleStatusReducer = function drizzleStatusReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];
          /*
           * Drizzle Status
           */

          if (action.type === 'DRIZZLE_INITIALIZED') {
            return (0, _extends3.default)({}, state, {
              initialized: true
            });
          }

          return state;
        };

        exports.default = drizzleStatusReducer;
        /***/
      },

      /***/
      "./src/drizzleStatus/drizzleStatusSaga.js":
      /*!************************************************!*\
        !*** ./src/drizzleStatus/drizzleStatusSaga.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function srcDrizzleStatusDrizzleStatusSagaJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _regenerator = __webpack_require__(
        /*! babel-runtime/regenerator */
        "./node_modules/babel-runtime/regenerator/index.js");

        var _regenerator2 = _interopRequireDefault(_regenerator);

        var _effects = __webpack_require__(
        /*! redux-saga/effects */
        "./node_modules/redux-saga/es/effects.js");

        var _defaultOptions = __webpack_require__(
        /*! ../defaultOptions */
        "./src/defaultOptions.js");

        var _defaultOptions2 = _interopRequireDefault(_defaultOptions);

        var _mergeOptions = __webpack_require__(
        /*! ../mergeOptions */
        "./src/mergeOptions.js");

        var _mergeOptions2 = _interopRequireDefault(_mergeOptions);

        var _web3Saga = __webpack_require__(
        /*! ../web3/web3Saga */
        "./src/web3/web3Saga.js");

        var _accountsSaga = __webpack_require__(
        /*! ../accounts/accountsSaga */
        "./src/accounts/accountsSaga.js");

        var _accountBalancesSaga = __webpack_require__(
        /*! ../accountBalances/accountBalancesSaga */
        "./src/accountBalances/accountBalancesSaga.js");

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var _marked =
        /*#__PURE__*/
        _regenerator2.default.mark(initializeDrizzle),
            _marked2 =
        /*#__PURE__*/
        _regenerator2.default.mark(drizzleStatusSaga); // Initialization Functions


        function initializeDrizzle(action) {
          var options, web3Options, drizzle, web3, i, contractConfig, events, contractName, syncAlways, interval;
          return _regenerator2.default.wrap(function initializeDrizzle$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  options = (0, _mergeOptions2.default)(_defaultOptions2.default, action.options);
                  web3Options = options.web3;
                  drizzle = action.drizzle; // Initialize web3 and get the current network ID.

                  _context.next = 6;
                  return (0, _effects.call)(_web3Saga.initializeWeb3, {
                    options: web3Options
                  });

                case 6:
                  web3 = _context.sent;
                  drizzle.web3 = web3;
                  _context.next = 10;
                  return (0, _effects.call)(_web3Saga.getNetworkId, {
                    web3: web3
                  });

                case 10:
                  _context.next = 12;
                  return (0, _effects.call)(_accountsSaga.getAccounts, {
                    web3: web3
                  });

                case 12:
                  _context.next = 14;
                  return (0, _effects.call)(_accountBalancesSaga.getAccountBalances, {
                    web3: web3
                  });

                case 14:
                  i = 0;

                case 15:
                  if (!(i < options.contracts.length)) {
                    _context.next = 25;
                    break;
                  }

                  contractConfig = options.contracts[i];
                  events = [];
                  contractName = contractConfig.contractName;

                  if (contractName in options.events) {
                    events = options.events[contractName];
                  }

                  _context.next = 22;
                  return (0, _effects.put)({
                    type: 'ADD_CONTRACT',
                    drizzle: drizzle,
                    contractConfig: contractConfig,
                    events: events,
                    web3: web3
                  });

                case 22:
                  i++;
                  _context.next = 15;
                  break;

                case 25:
                  syncAlways = options.syncAlways;

                  if (!(web3.currentProvider.isMetaMask && !window.ethereum)) {
                    _context.next = 32;
                    break;
                  } // Using old MetaMask, attempt block polling.


                  interval = options.polls.blocks;
                  _context.next = 30;
                  return (0, _effects.put)({
                    type: 'BLOCKS_POLLING',
                    drizzle: drizzle,
                    interval: interval,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 30:
                  _context.next = 34;
                  break;

                case 32:
                  _context.next = 34;
                  return (0, _effects.put)({
                    type: 'BLOCKS_LISTENING',
                    drizzle: drizzle,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 34:
                  if (!('accounts' in options.polls)) {
                    _context.next = 37;
                    break;
                  }

                  _context.next = 37;
                  return (0, _effects.put)({
                    type: 'ACCOUNTS_POLLING',
                    interval: options.polls.accounts,
                    web3: web3
                  });

                case 37:
                  _context.next = 46;
                  break;

                case 39:
                  _context.prev = 39;
                  _context.t0 = _context['catch'](0);
                  _context.next = 43;
                  return (0, _effects.put)({
                    type: 'DRIZZLE_FAILED',
                    error: _context.t0
                  });

                case 43:
                  console.error('Error initializing Drizzle:');
                  console.error(_context.t0);
                  return _context.abrupt('return');

                case 46:
                  _context.next = 48;
                  return (0, _effects.put)({
                    type: 'DRIZZLE_INITIALIZED'
                  });

                case 48:
                case 'end':
                  return _context.stop();
              }
            }
          }, _marked, this, [[0, 39]]);
        }

        function drizzleStatusSaga() {
          return _regenerator2.default.wrap(function drizzleStatusSaga$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return (0, _effects.takeLatest)('DRIZZLE_INITIALIZING', initializeDrizzle);

                case 2:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _marked2, this);
        }

        exports.default = drizzleStatusSaga;
        /***/
      },

      /***/
      "./src/generateContractInitialState.js":
      /*!*********************************************!*\
        !*** ./src/generateContractInitialState.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function srcGenerateContractInitialStateJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.generateContractInitialState = generateContractInitialState;

        var _getAbi = __webpack_require__(
        /*! ./getAbi */
        "./src/getAbi.js");

        var _getAbi2 = _interopRequireDefault(_getAbi);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function generateContractInitialState(contractConfig) {
          var state = {
            initialized: false,
            synced: false // Constant getters

          };
          var abi = (0, _getAbi2.default)(contractConfig);

          for (var i2 = 0; i2 < abi.length; i2++) {
            var item = abi[i2];

            if (item.type == 'function' && item.constant === true) {
              state[item.name] = {};
            }
          }

          return state;
        }
        /***/

      },

      /***/
      "./src/generateContractsInitialState.js":
      /*!**********************************************!*\
        !*** ./src/generateContractsInitialState.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function srcGenerateContractsInitialStateJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.generateContractsInitialState = generateContractsInitialState;

        var _generateContractInitialState = __webpack_require__(
        /*! ./generateContractInitialState */
        "./src/generateContractInitialState.js");

        function generateContractsInitialState(options) {
          // Preloaded state
          var contractsInitialState = {};

          for (var i = 0; i < options.contracts.length; i++) {
            // Initial contract details
            var contractName = options.contracts[i].contractName;
            contractsInitialState[contractName] = (0, _generateContractInitialState.generateContractInitialState)(options.contracts[i]);
          }

          return contractsInitialState;
        }
        /***/

      },

      /***/
      "./src/generateStore.js":
      /*!******************************!*\
        !*** ./src/generateStore.js ***!
        \******************************/

      /*! no static exports found */

      /***/
      function srcGenerateStoreJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.generateStore = generateStore;

        var _redux = __webpack_require__(
        /*! redux */
        "redux");

        var _reduxSaga = __webpack_require__(
        /*! redux-saga */
        "redux-saga");

        var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

        var _rootSaga = __webpack_require__(
        /*! ./rootSaga */
        "./src/rootSaga.js");

        var _rootSaga2 = _interopRequireDefault(_rootSaga);

        var _reducer = __webpack_require__(
        /*! ./reducer */
        "./src/reducer.js");

        var _reducer2 = _interopRequireDefault(_reducer);

        var _generateContractsInitialState = __webpack_require__(
        /*! ./generateContractsInitialState */
        "./src/generateContractsInitialState.js");

        var _getAbi = __webpack_require__(
        /*! ./getAbi */
        "./src/getAbi.js");

        var _getAbi2 = _interopRequireDefault(_getAbi);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function generateStore(options) {
          // Redux DevTools
          var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose; // Preloaded state

          var preloadedState = {
            contracts: (0, _generateContractsInitialState.generateContractsInitialState)(options) // create the saga middleware

          };
          var sagaMiddleware = (0, _reduxSaga2.default)();
          var store = (0, _redux.createStore)(_reducer2.default, preloadedState, composeEnhancers((0, _redux.applyMiddleware)(sagaMiddleware)));
          sagaMiddleware.run(_rootSaga2.default);
          return store;
        }
        /***/

      },

      /***/
      "./src/getAbi.js":
      /*!***********************!*\
        !*** ./src/getAbi.js ***!
        \***********************/

      /*! no static exports found */

      /***/
      function srcGetAbiJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = getAbi;

        function getAbi(contractEntry) {
          if (contractEntry.web3Contract) {
            return contractEntry.web3Contract.options.jsonInterface;
          } else {
            return contractEntry.abi;
          }
        }
        /***/

      },

      /***/
      "./src/index.js":
      /*!**********************!*\
        !*** ./src/index.js ***!
        \**********************/

      /*! no static exports found */

      /***/
      function srcIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.drizzleSagas = exports.drizzleReducers = exports.generateStore = exports.generateContractsInitialState = exports.Drizzle = undefined;

        var _Drizzle = __webpack_require__(
        /*! ./Drizzle.js */
        "./src/Drizzle.js");

        var _Drizzle2 = _interopRequireDefault(_Drizzle);

        var _generateStore = __webpack_require__(
        /*! ./generateStore */
        "./src/generateStore.js");

        var _generateContractsInitialState = __webpack_require__(
        /*! ./generateContractsInitialState */
        "./src/generateContractsInitialState.js");

        var _accountsReducer = __webpack_require__(
        /*! ./accounts/accountsReducer */
        "./src/accounts/accountsReducer.js");

        var _accountsReducer2 = _interopRequireDefault(_accountsReducer);

        var _accountBalancesReducer = __webpack_require__(
        /*! ./accountBalances/accountBalancesReducer */
        "./src/accountBalances/accountBalancesReducer.js");

        var _accountBalancesReducer2 = _interopRequireDefault(_accountBalancesReducer);

        var _contractsReducer = __webpack_require__(
        /*! ./contracts/contractsReducer */
        "./src/contracts/contractsReducer.js");

        var _contractsReducer2 = _interopRequireDefault(_contractsReducer);

        var _drizzleStatusReducer = __webpack_require__(
        /*! ./drizzleStatus/drizzleStatusReducer */
        "./src/drizzleStatus/drizzleStatusReducer.js");

        var _drizzleStatusReducer2 = _interopRequireDefault(_drizzleStatusReducer);

        var _transactionsReducer = __webpack_require__(
        /*! ./transactions/transactionsReducer */
        "./src/transactions/transactionsReducer.js");

        var _transactionsReducer2 = _interopRequireDefault(_transactionsReducer);

        var _transactionStackReducer = __webpack_require__(
        /*! ./transactions/transactionStackReducer */
        "./src/transactions/transactionStackReducer.js");

        var _transactionStackReducer2 = _interopRequireDefault(_transactionStackReducer);

        var _web3Reducer = __webpack_require__(
        /*! ./web3/web3Reducer */
        "./src/web3/web3Reducer.js");

        var _web3Reducer2 = _interopRequireDefault(_web3Reducer);

        var _accountsSaga = __webpack_require__(
        /*! ./accounts/accountsSaga */
        "./src/accounts/accountsSaga.js");

        var _accountsSaga2 = _interopRequireDefault(_accountsSaga);

        var _accountBalancesSaga = __webpack_require__(
        /*! ./accountBalances/accountBalancesSaga */
        "./src/accountBalances/accountBalancesSaga.js");

        var _accountBalancesSaga2 = _interopRequireDefault(_accountBalancesSaga);

        var _blocksSaga = __webpack_require__(
        /*! ./blocks/blocksSaga */
        "./src/blocks/blocksSaga.js");

        var _blocksSaga2 = _interopRequireDefault(_blocksSaga);

        var _contractsSaga = __webpack_require__(
        /*! ./contracts/contractsSaga */
        "./src/contracts/contractsSaga.js");

        var _contractsSaga2 = _interopRequireDefault(_contractsSaga);

        var _drizzleStatusSaga = __webpack_require__(
        /*! ./drizzleStatus/drizzleStatusSaga */
        "./src/drizzleStatus/drizzleStatusSaga.js");

        var _drizzleStatusSaga2 = _interopRequireDefault(_drizzleStatusSaga);

        var _web3Saga = __webpack_require__(
        /*! ./web3/web3Saga */
        "./src/web3/web3Saga.js");

        var _web3Saga2 = _interopRequireDefault(_web3Saga);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var drizzleReducers = {
          accounts: _accountsReducer2.default,
          accountBalances: _accountBalancesReducer2.default,
          contracts: _contractsReducer2.default,
          drizzleStatus: _drizzleStatusReducer2.default,
          transactions: _transactionsReducer2.default,
          transactionStack: _transactionStackReducer2.default,
          web3: _web3Reducer2.default // Sagas

        }; // Reducers

        var drizzleSagas = [_accountsSaga2.default, _accountBalancesSaga2.default, _blocksSaga2.default, _contractsSaga2.default, _drizzleStatusSaga2.default, _web3Saga2.default];
        exports.Drizzle = _Drizzle2.default;
        exports.generateContractsInitialState = _generateContractsInitialState.generateContractsInitialState;
        exports.generateStore = _generateStore.generateStore;
        exports.drizzleReducers = drizzleReducers;
        exports.drizzleSagas = drizzleSagas;
        /***/
      },

      /***/
      "./src/mergeOptions.js":
      /*!*****************************!*\
        !*** ./src/mergeOptions.js ***!
        \*****************************/

      /*! no static exports found */

      /***/
      function srcMergeOptionsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        exports.default = function (defaultOptions, newOptions) {
          return (0, _deepmerge2.default)(defaultOptions, newOptions, {
            isMergeableObject: isPlainObject
          });
        };

        var _deepmerge = __webpack_require__(
        /*! deepmerge */
        "deepmerge");

        var _deepmerge2 = _interopRequireDefault(_deepmerge);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var isPlainObject = __webpack_require__(
        /*! is-plain-object */
        "is-plain-object");
        /***/

      },

      /***/
      "./src/reducer.js":
      /*!************************!*\
        !*** ./src/reducer.js ***!
        \************************/

      /*! no static exports found */

      /***/
      function srcReducerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _redux = __webpack_require__(
        /*! redux */
        "redux");

        var _accountsReducer = __webpack_require__(
        /*! ./accounts/accountsReducer */
        "./src/accounts/accountsReducer.js");

        var _accountsReducer2 = _interopRequireDefault(_accountsReducer);

        var _accountBalancesReducer = __webpack_require__(
        /*! ./accountBalances/accountBalancesReducer */
        "./src/accountBalances/accountBalancesReducer.js");

        var _accountBalancesReducer2 = _interopRequireDefault(_accountBalancesReducer);

        var _contractsReducer = __webpack_require__(
        /*! ./contracts/contractsReducer */
        "./src/contracts/contractsReducer.js");

        var _contractsReducer2 = _interopRequireDefault(_contractsReducer);

        var _drizzleStatusReducer = __webpack_require__(
        /*! ./drizzleStatus/drizzleStatusReducer */
        "./src/drizzleStatus/drizzleStatusReducer.js");

        var _drizzleStatusReducer2 = _interopRequireDefault(_drizzleStatusReducer);

        var _transactionsReducer = __webpack_require__(
        /*! ./transactions/transactionsReducer */
        "./src/transactions/transactionsReducer.js");

        var _transactionsReducer2 = _interopRequireDefault(_transactionsReducer);

        var _transactionStackReducer = __webpack_require__(
        /*! ./transactions/transactionStackReducer */
        "./src/transactions/transactionStackReducer.js");

        var _transactionStackReducer2 = _interopRequireDefault(_transactionStackReducer);

        var _web3Reducer = __webpack_require__(
        /*! ./web3/web3Reducer */
        "./src/web3/web3Reducer.js");

        var _web3Reducer2 = _interopRequireDefault(_web3Reducer);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var reducer = (0, _redux.combineReducers)({
          accounts: _accountsReducer2.default,
          accountBalances: _accountBalancesReducer2.default,
          contracts: _contractsReducer2.default,
          drizzleStatus: _drizzleStatusReducer2.default,
          transactions: _transactionsReducer2.default,
          transactionStack: _transactionStackReducer2.default,
          web3: _web3Reducer2.default
        });
        exports.default = reducer;
        /***/
      },

      /***/
      "./src/rootSaga.js":
      /*!*************************!*\
        !*** ./src/rootSaga.js ***!
        \*************************/

      /*! no static exports found */

      /***/
      function srcRootSagaJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _regenerator = __webpack_require__(
        /*! babel-runtime/regenerator */
        "./node_modules/babel-runtime/regenerator/index.js");

        var _regenerator2 = _interopRequireDefault(_regenerator);

        exports.default = root;

        var _effects = __webpack_require__(
        /*! redux-saga/effects */
        "./node_modules/redux-saga/es/effects.js");

        var _accountsSaga = __webpack_require__(
        /*! ./accounts/accountsSaga */
        "./src/accounts/accountsSaga.js");

        var _accountsSaga2 = _interopRequireDefault(_accountsSaga);

        var _accountBalancesSaga = __webpack_require__(
        /*! ./accountBalances/accountBalancesSaga */
        "./src/accountBalances/accountBalancesSaga.js");

        var _accountBalancesSaga2 = _interopRequireDefault(_accountBalancesSaga);

        var _blocksSaga = __webpack_require__(
        /*! ./blocks/blocksSaga */
        "./src/blocks/blocksSaga.js");

        var _blocksSaga2 = _interopRequireDefault(_blocksSaga);

        var _contractsSaga = __webpack_require__(
        /*! ./contracts/contractsSaga */
        "./src/contracts/contractsSaga.js");

        var _contractsSaga2 = _interopRequireDefault(_contractsSaga);

        var _drizzleStatusSaga = __webpack_require__(
        /*! ./drizzleStatus/drizzleStatusSaga */
        "./src/drizzleStatus/drizzleStatusSaga.js");

        var _drizzleStatusSaga2 = _interopRequireDefault(_drizzleStatusSaga);

        var _web3Saga = __webpack_require__(
        /*! ./web3/web3Saga */
        "./src/web3/web3Saga.js");

        var _web3Saga2 = _interopRequireDefault(_web3Saga);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var _marked =
        /*#__PURE__*/
        _regenerator2.default.mark(root);

        function root() {
          return _regenerator2.default.wrap(function root$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return (0, _effects.all)([(0, _effects.fork)(_accountsSaga2.default), (0, _effects.fork)(_accountBalancesSaga2.default), (0, _effects.fork)(_blocksSaga2.default), (0, _effects.fork)(_contractsSaga2.default), (0, _effects.fork)(_drizzleStatusSaga2.default), (0, _effects.fork)(_web3Saga2.default)]);

                case 2:
                case 'end':
                  return _context.stop();
              }
            }
          }, _marked, this);
        }
        /***/

      },

      /***/
      "./src/transactions/transactionStackReducer.js":
      /*!*****************************************************!*\
        !*** ./src/transactions/transactionStackReducer.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function srcTransactionsTransactionStackReducerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _toConsumableArray2 = __webpack_require__(
        /*! babel-runtime/helpers/toConsumableArray */
        "./node_modules/babel-runtime/helpers/toConsumableArray.js");

        var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var initialState = [];

        var transactionStackReducer = function transactionStackReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];

          if (action.type === 'PUSH_TO_TXSTACK') {
            state.push('');
            return [].concat((0, _toConsumableArray3.default)(state));
          }

          if (action.type === 'POP_FROM_TXSTACK') {
            state.pop();
            return [].concat((0, _toConsumableArray3.default)(state));
          }

          if (action.type === 'TX_BROADCASTED') {
            state[action.stackId] = action.txHash;
            return [].concat((0, _toConsumableArray3.default)(state));
          }

          return state;
        };

        exports.default = transactionStackReducer;
        /***/
      },

      /***/
      "./src/transactions/transactionsReducer.js":
      /*!*************************************************!*\
        !*** ./src/transactions/transactionsReducer.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function srcTransactionsTransactionsReducerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _toConsumableArray2 = __webpack_require__(
        /*! babel-runtime/helpers/toConsumableArray */
        "./node_modules/babel-runtime/helpers/toConsumableArray.js");

        var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

        var _defineProperty2 = __webpack_require__(
        /*! babel-runtime/helpers/defineProperty */
        "./node_modules/babel-runtime/helpers/defineProperty.js");

        var _defineProperty3 = _interopRequireDefault(_defineProperty2);

        var _extends6 = __webpack_require__(
        /*! babel-runtime/helpers/extends */
        "./node_modules/babel-runtime/helpers/extends.js");

        var _extends7 = _interopRequireDefault(_extends6);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var initialState = {};

        var transactionsReducer = function transactionsReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];

          if (action.type === 'TX_BROADCASTED') {
            return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.txHash, {
              status: 'pending',
              confirmations: []
            }));
          }

          if (action.type === 'TX_CONFIRMAITON') {
            return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.txHash, (0, _extends7.default)({}, state[action.txHash], {
              confirmations: [].concat((0, _toConsumableArray3.default)(state[action.txHash].confirmations), [action.confirmationReceipt])
            })));
          }

          if (action.type === 'TX_SUCCESSFUL') {
            return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.txHash, (0, _extends7.default)({}, state[action.txHash], {
              status: 'success',
              receipt: action.receipt
            })));
          }

          if (action.type === 'TX_ERROR') {
            return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.txHash, (0, _extends7.default)({}, state[action.txHash], {
              status: 'error',
              error: action.error
            })));
          }

          return state;
        };

        exports.default = transactionsReducer;
        /***/
      },

      /***/
      "./src/web3/web3Reducer.js":
      /*!*********************************!*\
        !*** ./src/web3/web3Reducer.js ***!
        \*********************************/

      /*! no static exports found */

      /***/
      function srcWeb3Web3ReducerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends2 = __webpack_require__(
        /*! babel-runtime/helpers/extends */
        "./node_modules/babel-runtime/helpers/extends.js");

        var _extends3 = _interopRequireDefault(_extends2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var initialState = {
          status: ''
        };

        var web3Reducer = function web3Reducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];

          if (action.type === 'WEB3_INITIALIZING') {
            return (0, _extends3.default)({}, state, {
              status: 'initializing'
            });
          }

          if (action.type === 'WEB3_INITIALIZED') {
            return (0, _extends3.default)({}, state, {
              status: 'initialized'
            });
          }

          if (action.type === 'WEB3_FAILED') {
            return (0, _extends3.default)({}, state, {
              status: 'failed'
            });
          }

          if (action.type === 'NETWORK_ID_FETCHED') {
            return (0, _extends3.default)({}, state, {
              networkId: action.networkId
            });
          }

          if (action.type === 'NETWORK_ID_FAILED') {
            return (0, _extends3.default)({}, state, {
              networkId: action.networkId
            });
          }

          return state;
        };

        exports.default = web3Reducer;
        /***/
      },

      /***/
      "./src/web3/web3Saga.js":
      /*!******************************!*\
        !*** ./src/web3/web3Saga.js ***!
        \******************************/

      /*! no static exports found */

      /***/
      function srcWeb3Web3SagaJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _regenerator = __webpack_require__(
        /*! babel-runtime/regenerator */
        "./node_modules/babel-runtime/regenerator/index.js");

        var _regenerator2 = _interopRequireDefault(_regenerator);

        exports.initializeWeb3 = initializeWeb3;
        exports.getNetworkId = getNetworkId;

        var _effects = __webpack_require__(
        /*! redux-saga/effects */
        "./node_modules/redux-saga/es/effects.js");

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var _marked =
        /*#__PURE__*/
        _regenerator2.default.mark(initializeWeb3),
            _marked2 =
        /*#__PURE__*/
        _regenerator2.default.mark(getNetworkId),
            _marked3 =
        /*#__PURE__*/
        _regenerator2.default.mark(callSendTx),
            _marked4 =
        /*#__PURE__*/
        _regenerator2.default.mark(web3Saga);

        var Web3 = __webpack_require__(
        /*! web3 */
        "web3");
        /*
         * Initialization
         */


        function initializeWeb3(_ref) {
          var options = _ref.options;

          var web3, _window, ethereum, provider;

          return _regenerator2.default.wrap(function initializeWeb3$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  web3 = {};

                  if (!window.ethereum) {
                    _context.next = 19;
                    break;
                  }

                  _window = window, ethereum = _window.ethereum;
                  web3 = new Web3(ethereum);
                  _context.prev = 5;
                  _context.next = 8;
                  return (0, _effects.call)(ethereum.enable);

                case 8:
                  web3.eth.cacheSendTransaction = function (txObject) {
                    return (0, _effects.put)({
                      type: 'SEND_WEB3_TX',
                      txObject: txObject,
                      stackId: stackId,
                      web3: web3
                    });
                  };

                  _context.next = 11;
                  return (0, _effects.put)({
                    type: 'WEB3_INITIALIZED'
                  });

                case 11:
                  return _context.abrupt('return', web3);

                case 14:
                  _context.prev = 14;
                  _context.t0 = _context['catch'](5); // User denied account access...

                  console.log(_context.t0);

                case 17:
                  _context.next = 42;
                  break;

                case 19:
                  if (!(typeof window.web3 !== 'undefined')) {
                    _context.next = 28;
                    break;
                  } // Use Mist/MetaMask's provider.


                  web3 = new Web3(window.web3.currentProvider);

                  web3.eth.cacheSendTransaction = function (txObject) {
                    return (0, _effects.put)({
                      type: 'SEND_WEB3_TX',
                      txObject: txObject,
                      stackId: stackId,
                      web3: web3
                    });
                  };

                  console.log('Injected web3 detected.');
                  _context.next = 25;
                  return (0, _effects.put)({
                    type: 'WEB3_INITIALIZED'
                  });

                case 25:
                  return _context.abrupt('return', web3);

                case 28:
                  if (!options.fallback) {
                    _context.next = 41;
                    break;
                  } // Attempt fallback if no web3 injection.


                  console.log('No web3 instance injected, using fallback.');
                  _context.t1 = options.fallback.type;
                  _context.next = _context.t1 === 'ws' ? 33 : 40;
                  break;

                case 33:
                  provider = new Web3.providers.WebsocketProvider(options.fallback.url);
                  web3 = new Web3(provider); // Attach drizzle functions

                  web3.eth['cacheSendTransaction'] = function (txObject) {
                    return (0, _effects.put)({
                      type: 'SEND_WEB3_TX',
                      txObject: txObject,
                      stackId: stackId,
                      web3: web3
                    });
                  };

                  _context.next = 38;
                  return (0, _effects.put)({
                    type: 'WEB3_INITIALIZED'
                  });

                case 38:
                  return _context.abrupt('return', web3);

                case 40:
                  throw 'Invalid web3 fallback provided.';

                case 41:
                  throw 'Cannot find injected web3 or valid fallback.';

                case 42:
                  _context.next = 50;
                  break;

                case 44:
                  _context.prev = 44;
                  _context.t2 = _context['catch'](0);
                  _context.next = 48;
                  return (0, _effects.put)({
                    type: 'WEB3_FAILED',
                    error: _context.t2
                  });

                case 48:
                  console.error('Error intializing web3:');
                  console.error(_context.t2);

                case 50:
                case 'end':
                  return _context.stop();
              }
            }
          }, _marked, this, [[0, 44], [5, 14]]);
        }
        /*
         * Network ID
         */


        function getNetworkId(_ref2) {
          var web3 = _ref2.web3;
          var networkId;
          return _regenerator2.default.wrap(function getNetworkId$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return (0, _effects.call)(web3.eth.net.getId);

                case 3:
                  networkId = _context2.sent;
                  _context2.next = 6;
                  return (0, _effects.put)({
                    type: 'NETWORK_ID_FETCHED',
                    networkId: networkId
                  });

                case 6:
                  return _context2.abrupt('return', networkId);

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2['catch'](0);
                  _context2.next = 13;
                  return (0, _effects.put)({
                    type: 'NETWORK_ID_FAILED',
                    error: _context2.t0
                  });

                case 13:
                  console.error('Error fetching network ID:');
                  console.error(_context2.t0);

                case 15:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _marked2, this, [[0, 9]]);
        }
        /*
         * Send Transaction
         */


        function createTxChannel(_ref3) {
          var txObject = _ref3.txObject,
              stackId = _ref3.stackId,
              web3 = _ref3.web3;
          var persistTxHash;
          return eventChannel(function (emit) {
            var txPromiEvent = web3.eth.sendTransaction(txObject).on('transactionHash', function (txHash) {
              persistTxHash = txHash;
              emit({
                type: 'W3TX_BROADCASTED',
                txHash: txHash,
                stackId: stackId
              });
            }).on('confirmation', function (confirmationNumber, receipt) {
              emit({
                type: 'W3TX_CONFIRMAITON',
                confirmationReceipt: receipt,
                txHash: persistTxHash
              });
            }).on('receipt', function (receipt) {
              emit({
                type: 'W3TX_SUCCESSFUL',
                receipt: receipt,
                txHash: persistTxHash
              });
              emit(END);
            }).on('error', function (error) {
              emit({
                type: 'W3TX_ERROR',
                error: error,
                txHash: persistTxHash
              });
              emit(END);
            });

            var unsubscribe = function unsubscribe() {
              txPromiEvent.off();
            };

            return unsubscribe;
          });
        }

        function callSendTx(_ref4) {
          var txObject = _ref4.txObject,
              stackId = _ref4.stackId,
              web3 = _ref4.web3;
          var txChannel, event;
          return _regenerator2.default.wrap(function callSendTx$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0, _effects.call)(createTxChannel, {
                    txObject: txObject,
                    stackId: stackId,
                    web3: web3
                  });

                case 2:
                  txChannel = _context3.sent;
                  _context3.prev = 3;

                case 4:
                  if (false) {}

                  _context3.next = 7;
                  return take(txChannel);

                case 7:
                  event = _context3.sent;
                  _context3.next = 10;
                  return (0, _effects.put)(event);

                case 10:
                  _context3.next = 4;
                  break;

                case 12:
                  _context3.prev = 12;
                  txChannel.close();
                  return _context3.finish(12);

                case 15:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _marked3, this, [[3,, 12, 15]]);
        }

        function web3Saga() {
          return _regenerator2.default.wrap(function web3Saga$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return (0, _effects.takeLatest)('NETWORK_ID_FETCHING', getNetworkId);

                case 2:
                  _context4.next = 4;
                  return (0, _effects.takeEvery)('SEND_WEB3_TX', callSendTx);

                case 4:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _marked4, this);
        }

        exports.default = web3Saga;
        /***/
      },

      /***/
      "deepmerge":
      /*!****************************!*\
        !*** external "deepmerge" ***!
        \****************************/

      /*! no static exports found */

      /***/
      function deepmerge(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_deepmerge__;
        /***/
      },

      /***/
      "eth-block-tracker":
      /*!****************************************!*\
        !*** external "eth-block-tracker-es5" ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function ethBlockTracker(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_eth_block_tracker__;
        /***/
      },

      /***/
      "is-plain-object":
      /*!**********************************!*\
        !*** external "is-plain-object" ***!
        \**********************************/

      /*! no static exports found */

      /***/
      function isPlainObject(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_is_plain_object__;
        /***/
      },

      /***/
      "redux":
      /*!************************!*\
        !*** external "redux" ***!
        \************************/

      /*! no static exports found */

      /***/
      function redux(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_redux__;
        /***/
      },

      /***/
      "redux-saga":
      /*!*****************************!*\
        !*** external "redux-saga" ***!
        \*****************************/

      /*! no static exports found */

      /***/
      function reduxSaga(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_redux_saga__;
        /***/
      },

      /***/
      "web3":
      /*!***********************!*\
        !*** external "web3" ***!
        \***********************/

      /*! no static exports found */

      /***/
      function web3(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_web3__;
        /***/
      }
      /******/

    })
  );
});